export default [{
    label: {
      translate: 'emoji.label.smileys',
      fix: 'Smileys et personnes',
    },
    icon: {
      ch: '😀',
      cp: '1f600'
    },
    emojis: [{
        ch: '😀',
        cp: '1f600'
      },
      {
        ch: '😃',
        cp: '1f603'
      },
      {
        ch: '😄',
        cp: '1f604'
      },
      {
        ch: '😁',
        cp: '1f601'
      },
      {
        ch: '😆',
        cp: '1f606'
      },
      {
        ch: '😅',
        cp: '1f605'
      },
      {
        ch: '😂',
        cp: '1f602'
      },
      {
        ch: '🤣',
        cp: '1f923'
      },
      {
        ch: '😇',
        cp: '1f607'
      },
      {
        ch: '😉',
        cp: '1f609'
      },
      {
        ch: '😊',
        cp: '1f60a'
      },
      {
        ch: '🙂',
        cp: '1f642'
      },
      {
        ch: '🙃',
        cp: '1f643'
      },
      {
        ch: '☺',
        cp: '263a'
      },
      {
        ch: '😋',
        cp: '1f60b'
      },
      {
        ch: '😌',
        cp: '1f60c'
      },
      {
        ch: '😍',
        cp: '1f60d'
      },
      {
        ch: '🥰',
        cp: '1f970'
      },
      {
        ch: '😘',
        cp: '1f618'
      },
      {
        ch: '😗',
        cp: '1f617'
      },
      {
        ch: '😙',
        cp: '1f619'
      },
      {
        ch: '😚',
        cp: '1f61a'
      },
      {
        ch: '🤪',
        cp: '1f92a'
      },
      {
        ch: '😜',
        cp: '1f61c'
      },
      {
        ch: '😝',
        cp: '1f61d'
      },
      {
        ch: '😛',
        cp: '1f61b'
      },
      {
        ch: '🤑',
        cp: '1f911'
      },
      {
        ch: '😎',
        cp: '1f60e'
      },
      {
        ch: '🤓',
        cp: '1f913'
      },
      {
        ch: '🧐',
        cp: '1f9d0'
      },
      {
        ch: '🤠',
        cp: '1f920'
      },
      {
        ch: '🥳',
        cp: '1f973'
      },
      {
        ch: '🤗',
        cp: '1f917'
      },
      {
        ch: '🤡',
        cp: '1f921'
      },
      {
        ch: '😏',
        cp: '1f60f'
      },
      {
        ch: '😶',
        cp: '1f636'
      },
      {
        ch: '😐',
        cp: '1f610'
      },
      {
        ch: '😑',
        cp: '1f611'
      },
      {
        ch: '😒',
        cp: '1f612'
      },
      {
        ch: '🙄',
        cp: '1f644'
      },
      {
        ch: '🤨',
        cp: '1f928'
      },
      {
        ch: '🤔',
        cp: '1f914'
      },
      {
        ch: '🤫',
        cp: '1f92b'
      },
      {
        ch: '🤭',
        cp: '1f92d'
      },
      {
        ch: '🤥',
        cp: '1f925'
      },
      {
        ch: '😳',
        cp: '1f633'
      },
      {
        ch: '😞',
        cp: '1f61e'
      },
      {
        ch: '😟',
        cp: '1f61f'
      },
      {
        ch: '😠',
        cp: '1f620'
      },
      {
        ch: '😡',
        cp: '1f621'
      },
      {
        ch: '🤬',
        cp: '1f92c'
      },
      {
        ch: '😔',
        cp: '1f614'
      },
      {
        ch: '😕',
        cp: '1f615'
      },
      {
        ch: '🙁',
        cp: '1f641'
      },
      {
        ch: '☹',
        cp: '2639'
      },
      {
        ch: '😬',
        cp: '1f62c'
      },
      {
        ch: '🥺',
        cp: '1f97a'
      },
      {
        ch: '😣',
        cp: '1f623'
      },
      {
        ch: '😖',
        cp: '1f616'
      },
      {
        ch: '😫',
        cp: '1f62b'
      },
      {
        ch: '😩',
        cp: '1f629'
      },
      {
        ch: '😤',
        cp: '1f624'
      },
      {
        ch: '😮',
        cp: '1f62e'
      },
      {
        ch: '😱',
        cp: '1f631'
      },
      {
        ch: '😨',
        cp: '1f628'
      },
      {
        ch: '😰',
        cp: '1f630'
      },
      {
        ch: '😯',
        cp: '1f62f'
      },
      {
        ch: '😦',
        cp: '1f626'
      },
      {
        ch: '😧',
        cp: '1f627'
      },
      {
        ch: '😢',
        cp: '1f622'
      },
      {
        ch: '😥',
        cp: '1f625'
      },
      {
        ch: '😪',
        cp: '1f62a'
      },
      {
        ch: '🤤',
        cp: '1f924'
      },
      {
        ch: '😓',
        cp: '1f613'
      },
      {
        ch: '😭',
        cp: '1f62d'
      },
      {
        ch: '🤩',
        cp: '1f929'
      },
      {
        ch: '😵',
        cp: '1f635'
      },
      {
        ch: '🥴',
        cp: '1f974'
      },
      {
        ch: '😲',
        cp: '1f632'
      },
      {
        ch: '🤯',
        cp: '1f92f'
      },
      {
        ch: '🤐',
        cp: '1f910'
      },
      {
        ch: '😷',
        cp: '1f637'
      },
      {
        ch: '🤕',
        cp: '1f915'
      },
      {
        ch: '🤒',
        cp: '1f912'
      },
      {
        ch: '🤮',
        cp: '1f92e'
      },
      {
        ch: '🤢',
        cp: '1f922'
      },
      {
        ch: '🤧',
        cp: '1f927'
      },
      {
        ch: '🥵',
        cp: '1f975'
      },
      {
        ch: '🥶',
        cp: '1f976'
      },
      {
        ch: '😴',
        cp: '1f634'
      },
      {
        ch: '💤',
        cp: '1f4a4'
      },
      {
        ch: '😈',
        cp: '1f608'
      },
      {
        ch: '👿',
        cp: '1f47f'
      },
      {
        ch: '👹',
        cp: '1f479'
      },
      {
        ch: '👺',
        cp: '1f47a'
      },
      {
        ch: '💩',
        cp: '1f4a9'
      },
      {
        ch: '👻',
        cp: '1f47b'
      },
      {
        ch: '💀',
        cp: '1f480'
      },
      {
        ch: '☠',
        cp: '2620'
      },
      {
        ch: '👽',
        cp: '1f47d'
      },
      {
        ch: '🤖',
        cp: '1f916'
      },
      {
        ch: '🎃',
        cp: '1f383'
      },
      {
        ch: '😺',
        cp: '1f63a'
      },
      {
        ch: '😸',
        cp: '1f638'
      },
      {
        ch: '😹',
        cp: '1f639'
      },
      {
        ch: '😻',
        cp: '1f63b'
      },
      {
        ch: '😼',
        cp: '1f63c'
      },
      {
        ch: '😽',
        cp: '1f63d'
      },
      {
        ch: '🙀',
        cp: '1f640'
      },
      {
        ch: '😿',
        cp: '1f63f'
      },
      {
        ch: '😾',
        cp: '1f63e'
      },
      {
        ch: '👐',
        cp: '1f450'
      },
      {
        ch: '🤲',
        cp: '1f932'
      },
      {
        ch: '🙌',
        cp: '1f64c'
      },
      {
        ch: '👏',
        cp: '1f44f'
      },
      {
        ch: '🙏',
        cp: '1f64f'
      },
      {
        ch: '🤝',
        cp: '1f91d'
      },
      {
        ch: '👍',
        cp: '1f44d'
      },
      {
        ch: '👎',
        cp: '1f44e'
      },
      {
        ch: '👊',
        cp: '1f44a'
      },
      {
        ch: '✊',
        cp: '270a'
      },
      {
        ch: '🤛',
        cp: '1f91b'
      },
      {
        ch: '🤜',
        cp: '1f91c'
      },
      {
        ch: '🤞',
        cp: '1f91e'
      },
      {
        ch: '✌',
        cp: '270c'
      },
      {
        ch: '🤘',
        cp: '1f918'
      },
      {
        ch: '🤟',
        cp: '1f91f'
      },
      {
        ch: '👌',
        cp: '1f44c'
      },
      {
        ch: '👈',
        cp: '1f448'
      },
      {
        ch: '👉',
        cp: '1f449'
      },
      {
        ch: '👆',
        cp: '1f446'
      },
      {
        ch: '👇',
        cp: '1f447'
      },
      {
        ch: '☝',
        cp: '261d'
      },
      {
        ch: '✋',
        cp: '270b'
      },
      {
        ch: '🤚',
        cp: '1f91a'
      },
      {
        ch: '🖐',
        cp: '1f590'
      },
      {
        ch: '🖖',
        cp: '1f596'
      },
      {
        ch: '👋',
        cp: '1f44b'
      },
      {
        ch: '🤙',
        cp: '1f919'
      },
      {
        ch: '💪',
        cp: '1f4aa'
      },
      {
        ch: '🖕',
        cp: '1f595'
      },
      {
        ch: '✍',
        cp: '270d'
      },
      {
        ch: '🤳',
        cp: '1f933'
      },
      {
        ch: '💅',
        cp: '1f485'
      },
      {
        ch: '🦵',
        cp: '1f9b5'
      },
      {
        ch: '🦶',
        cp: '1f9b6'
      },
      {
        ch: '👄',
        cp: '1f444'
      },
      {
        ch: '🦷',
        cp: '1f9b7'
      },
      {
        ch: '👅',
        cp: '1f445'
      },
      {
        ch: '👂',
        cp: '1f442'
      },
      {
        ch: '👃',
        cp: '1f443'
      },
      {
        ch: '👁',
        cp: '1f441'
      },
      {
        ch: '👀',
        cp: '1f440'
      },
      {
        ch: '🧠',
        cp: '1f9e0'
      },
      {
        ch: '🦴',
        cp: '1f9b4'
      },
      {
        ch: '👤',
        cp: '1f464'
      },
      {
        ch: '👥',
        cp: '1f465'
      },
      {
        ch: '🗣',
        cp: '1f5e3'
      },
      {
        ch: '👶',
        cp: '1f476'
      },
      {
        ch: '🧒',
        cp: '1f9d2'
      },
      {
        ch: '👦',
        cp: '1f466'
      },
      {
        ch: '👧',
        cp: '1f467'
      },
      {
        ch: '🧑',
        cp: '1f9d1'
      },
      {
        ch: '👨',
        cp: '1f468'
      },
      {
        ch: '🧔',
        cp: '1f9d4'
      },
      {
        ch: '👱‍♂️',
        cp: '1f471-200d-2642-fe0f'
      },
      {
        ch: '👨‍🦰',
        cp: '1f468-200d-1f9b0'
      },
      {
        ch: '👨‍🦱',
        cp: '1f468-200d-1f9b1'
      },
      {
        ch: '👨‍🦲',
        cp: '1f468-200d-1f9b2'
      },
      {
        ch: '👨‍🦳',
        cp: '1f468-200d-1f9b3'
      },
      {
        ch: '👩',
        cp: '1f469'
      },
      {
        ch: '👱‍♀️',
        cp: '1f471-200d-2640-fe0f'
      },
      {
        ch: '👩‍🦰',
        cp: '1f469-200d-1f9b0'
      },
      {
        ch: '👩‍🦱',
        cp: '1f469-200d-1f9b1'
      },
      {
        ch: '👩‍🦲',
        cp: '1f469-200d-1f9b2'
      },
      {
        ch: '👩‍🦳',
        cp: '1f469-200d-1f9b3'
      },
      {
        ch: '🧓',
        cp: '1f9d3'
      },
      {
        ch: '👴',
        cp: '1f474'
      },
      {
        ch: '👵',
        cp: '1f475'
      },
      {
        ch: '👲',
        cp: '1f472'
      },
      {
        ch: '👳‍♀️',
        cp: '1f473-200d-2640-fe0f'
      },
      {
        ch: '👳‍♂️',
        cp: '1f473-200d-2642-fe0f'
      },
      {
        ch: '🧕',
        cp: '1f9d5'
      },
      {
        ch: '👮‍♀️',
        cp: '1f46e-200d-2640-fe0f'
      },
      {
        ch: '👮‍♂️',
        cp: '1f46e-200d-2642-fe0f'
      },
      {
        ch: '👩‍🚒',
        cp: '1f469-200d-1f692'
      },
      {
        ch: '👨‍🚒',
        cp: '1f468-200d-1f692'
      },
      {
        ch: '👷‍♀️',
        cp: '1f477-200d-2640-fe0f'
      },
      {
        ch: '👷‍♂️',
        cp: '1f477-200d-2642-fe0f'
      },
      {
        ch: '👩‍🏭',
        cp: '1f469-200d-1f3ed'
      },
      {
        ch: '👨‍🏭',
        cp: '1f468-200d-1f3ed'
      },
      {
        ch: '👩‍🔧',
        cp: '1f469-200d-1f527'
      },
      {
        ch: '👨‍🔧',
        cp: '1f468-200d-1f527'
      },
      {
        ch: '👩‍🌾',
        cp: '1f469-200d-1f33e'
      },
      {
        ch: '👨‍🌾',
        cp: '1f468-200d-1f33e'
      },
      {
        ch: '👩‍🍳',
        cp: '1f469-200d-1f373'
      },
      {
        ch: '👨‍🍳',
        cp: '1f468-200d-1f373'
      },
      {
        ch: '👩‍🎤',
        cp: '1f469-200d-1f3a4'
      },
      {
        ch: '👨‍🎤',
        cp: '1f468-200d-1f3a4'
      },
      {
        ch: '👩‍🎨',
        cp: '1f469-200d-1f3a8'
      },
      {
        ch: '👨‍🎨',
        cp: '1f468-200d-1f3a8'
      },
      {
        ch: '👩‍🏫',
        cp: '1f469-200d-1f3eb'
      },
      {
        ch: '👨‍🏫',
        cp: '1f468-200d-1f3eb'
      },
      {
        ch: '👩‍🎓',
        cp: '1f469-200d-1f393'
      },
      {
        ch: '👨‍🎓',
        cp: '1f468-200d-1f393'
      },
      {
        ch: '👩‍💼',
        cp: '1f469-200d-1f4bc'
      },
      {
        ch: '👨‍💼',
        cp: '1f468-200d-1f4bc'
      },
      {
        ch: '👩‍💻',
        cp: '1f469-200d-1f4bb'
      },
      {
        ch: '👨‍💻',
        cp: '1f468-200d-1f4bb'
      },
      {
        ch: '👩‍🔬',
        cp: '1f469-200d-1f52c'
      },
      {
        ch: '👨‍🔬',
        cp: '1f468-200d-1f52c'
      },
      {
        ch: '👩‍🚀',
        cp: '1f469-200d-1f680'
      },
      {
        ch: '👨‍🚀',
        cp: '1f468-200d-1f680'
      },
      {
        ch: '👩‍⚕️',
        cp: '1f469-200d-2695-fe0f'
      },
      {
        ch: '👨‍⚕️',
        cp: '1f468-200d-2695-fe0f'
      },
      {
        ch: '👩‍⚖️',
        cp: '1f469-200d-2696-fe0f'
      },
      {
        ch: '👨‍⚖️',
        cp: '1f468-200d-2696-fe0f'
      },
      {
        ch: '👩‍✈️',
        cp: '1f469-200d-2708-fe0f'
      },
      {
        ch: '👨‍✈️',
        cp: '1f468-200d-2708-fe0f'
      },
      {
        ch: '💂‍♀️',
        cp: '1f482-200d-2640-fe0f'
      },
      {
        ch: '💂‍♂️',
        cp: '1f482-200d-2642-fe0f'
      },
      {
        ch: '🕵️‍♀️',
        cp: '1f575-fe0f-200d-2640-fe0f'
      },
      {
        ch: '🕵️‍♂️',
        cp: '1f575-fe0f-200d-2642-fe0f'
      },
      {
        ch: '🤶',
        cp: '1f936'
      },
      {
        ch: '🎅',
        cp: '1f385'
      },
      {
        ch: '👼',
        cp: '1f47c'
      },
      {
        ch: '👸',
        cp: '1f478'
      },
      {
        ch: '🤴',
        cp: '1f934'
      },
      {
        ch: '👰',
        cp: '1f470'
      },
      {
        ch: '🤵‍♀️',
        cp: '1f935-200d-2640-fe0f'
      },
      {
        ch: '🤵',
        cp: '1f935'
      },
      {
        ch: '🕴️‍♀️',
        cp: '1f574-fe0f-200d-2640-fe0f'
      },
      {
        ch: '🕴',
        cp: '1f574'
      },
      {
        ch: '🦸‍♀️',
        cp: '1f9b8-200d-2640-fe0f'
      },
      {
        ch: '🦸‍♂️',
        cp: '1f9b8-200d-2642-fe0f'
      },
      {
        ch: '🦹‍♀️',
        cp: '1f9b9-200d-2640-fe0f'
      },
      {
        ch: '🦹‍♂️',
        cp: '1f9b9-200d-2642-fe0f'
      },
      {
        ch: '🧙‍♀️',
        cp: '1f9d9-200d-2640-fe0f'
      },
      {
        ch: '🧙‍♂️',
        cp: '1f9d9-200d-2642-fe0f'
      },
      {
        ch: '🧝‍♀️',
        cp: '1f9dd-200d-2640-fe0f'
      },
      {
        ch: '🧝‍♂️',
        cp: '1f9dd-200d-2642-fe0f'
      },
      {
        ch: '🧚‍♀️',
        cp: '1f9da-200d-2640-fe0f'
      },
      {
        ch: '🧚‍♂️',
        cp: '1f9da-200d-2642-fe0f'
      },
      {
        ch: '🧞‍♀️',
        cp: '1f9de-200d-2640-fe0f'
      },
      {
        ch: '🧞‍♂️',
        cp: '1f9de-200d-2642-fe0f'
      },
      {
        ch: '🧜‍♀️',
        cp: '1f9dc-200d-2640-fe0f'
      },
      {
        ch: '🧜‍♂️',
        cp: '1f9dc-200d-2642-fe0f'
      },
      {
        ch: '🧛‍♀️',
        cp: '1f9db-200d-2640-fe0f'
      },
      {
        ch: '🧛‍♂️',
        cp: '1f9db-200d-2642-fe0f'
      },
      {
        ch: '🧟‍♀️',
        cp: '1f9df-200d-2640-fe0f'
      },
      {
        ch: '🧟‍♂️',
        cp: '1f9df-200d-2642-fe0f'
      },
      {
        ch: '🙇‍♀️',
        cp: '1f647-200d-2640-fe0f'
      },
      {
        ch: '🙇‍♂️',
        cp: '1f647-200d-2642-fe0f'
      },
      {
        ch: '💁‍♀️',
        cp: '1f481-200d-2640-fe0f'
      },
      {
        ch: '💁‍♂️',
        cp: '1f481-200d-2642-fe0f'
      },
      {
        ch: '🙅‍♀️',
        cp: '1f645-200d-2640-fe0f'
      },
      {
        ch: '🙅‍♂️',
        cp: '1f645-200d-2642-fe0f'
      },
      {
        ch: '🙆‍♀️',
        cp: '1f646-200d-2640-fe0f'
      },
      {
        ch: '🙆‍♂️',
        cp: '1f646-200d-2642-fe0f'
      },
      {
        ch: '🤷‍♀️',
        cp: '1f937-200d-2640-fe0f'
      },
      {
        ch: '🤷‍♂️',
        cp: '1f937-200d-2642-fe0f'
      },
      {
        ch: '🙋‍♀️',
        cp: '1f64b-200d-2640-fe0f'
      },
      {
        ch: '🙋‍♂️',
        cp: '1f64b-200d-2642-fe0f'
      },
      {
        ch: '🤦‍♀️',
        cp: '1f926-200d-2640-fe0f'
      },
      {
        ch: '🤦‍♂️',
        cp: '1f926-200d-2642-fe0f'
      },
      {
        ch: '🙎‍♀️',
        cp: '1f64e-200d-2640-fe0f'
      },
      {
        ch: '🙎‍♂️',
        cp: '1f64e-200d-2642-fe0f'
      },
      {
        ch: '🙍‍♀️',
        cp: '1f64d-200d-2640-fe0f'
      },
      {
        ch: '🙍‍♂️',
        cp: '1f64d-200d-2642-fe0f'
      },
      {
        ch: '💇‍♀️',
        cp: '1f487-200d-2640-fe0f'
      },
      {
        ch: '💇‍♂️',
        cp: '1f487-200d-2642-fe0f'
      },
      {
        ch: '💆‍♀️',
        cp: '1f486-200d-2640-fe0f'
      },
      {
        ch: '💆‍♂️',
        cp: '1f486-200d-2642-fe0f'
      },
      {
        ch: '🤰',
        cp: '1f930'
      },
      {
        ch: '🤱',
        cp: '1f931'
      },
      {
        ch: '🚶‍♀️',
        cp: '1f6b6-200d-2640-fe0f'
      },
      {
        ch: '🚶‍♂️',
        cp: '1f6b6-200d-2642-fe0f'
      },
      {
        ch: '🏃‍♀️',
        cp: '1f3c3-200d-2640-fe0f'
      },
      {
        ch: '🏃‍♂️',
        cp: '1f3c3-200d-2642-fe0f'
      },
      {
        ch: '💃',
        cp: '1f483'
      },
      {
        ch: '🕺',
        cp: '1f57a'
      },
      {
        ch: '👯‍♀️',
        cp: '1f46f-200d-2640-fe0f'
      },
      {
        ch: '👯‍♂️',
        cp: '1f46f-200d-2642-fe0f'
      },
      {
        ch: '👫',
        cp: '1f46b'
      },
      {
        ch: '👬',
        cp: '1f46c'
      },
      {
        ch: '👭',
        cp: '1f46d'
      },
      {
        ch: '💑',
        cp: '1f491'
      },
      {
        ch: '👩‍❤️‍👩',
        cp: '1f469-200d-2764-fe0f-200d-1f469'
      },
      {
        ch: '👨‍❤️‍👨',
        cp: '1f468-200d-2764-fe0f-200d-1f468'
      },
      {
        ch: '💏',
        cp: '1f48f'
      },
      {
        ch: '👩‍❤️‍💋‍👩',
        cp: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469'
      },
      {
        ch: '👨‍❤️‍💋‍👨',
        cp: '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468'
      },
      {
        ch: '👪',
        cp: '1f46a'
      },
      {
        ch: '👨‍👩‍👧',
        cp: '1f468-200d-1f469-200d-1f467'
      },
      {
        ch: '👨‍👩‍👧‍👦',
        cp: '1f468-200d-1f469-200d-1f467-200d-1f466'
      },
      {
        ch: '👨‍👩‍👦‍👦',
        cp: '1f468-200d-1f469-200d-1f466-200d-1f466'
      },
      {
        ch: '👨‍👩‍👧‍👧',
        cp: '1f468-200d-1f469-200d-1f467-200d-1f467'
      },
      {
        ch: '👩‍👩‍👦',
        cp: '1f469-200d-1f469-200d-1f466'
      },
      {
        ch: '👩‍👩‍👧',
        cp: '1f469-200d-1f469-200d-1f467'
      },
      {
        ch: '👩‍👩‍👧‍👦',
        cp: '1f469-200d-1f469-200d-1f467-200d-1f466'
      },
      {
        ch: '👩‍👩‍👦‍👦',
        cp: '1f469-200d-1f469-200d-1f466-200d-1f466'
      },
      {
        ch: '👩‍👩‍👧‍👧',
        cp: '1f469-200d-1f469-200d-1f467-200d-1f467'
      },
      {
        ch: '👨‍👨‍👦',
        cp: '1f468-200d-1f468-200d-1f466'
      },
      {
        ch: '👨‍👨‍👧',
        cp: '1f468-200d-1f468-200d-1f467'
      },
      {
        ch: '👨‍👨‍👧‍👦',
        cp: '1f468-200d-1f468-200d-1f467-200d-1f466'
      },
      {
        ch: '👨‍👨‍👦‍👦',
        cp: '1f468-200d-1f468-200d-1f466-200d-1f466'
      },
      {
        ch: '👨‍👨‍👧‍👧',
        cp: '1f468-200d-1f468-200d-1f467-200d-1f467'
      },
      {
        ch: '👩‍👦',
        cp: '1f469-200d-1f466'
      },
      {
        ch: '👩‍👧',
        cp: '1f469-200d-1f467'
      },
      {
        ch: '👩‍👧‍👦',
        cp: '1f469-200d-1f467-200d-1f466'
      },
      {
        ch: '👩‍👦‍👦',
        cp: '1f469-200d-1f466-200d-1f466'
      },
      {
        ch: '👩‍👧‍👧',
        cp: '1f469-200d-1f467-200d-1f467'
      },
      {
        ch: '👨‍👦',
        cp: '1f468-200d-1f466'
      },
      {
        ch: '👨‍👧',
        cp: '1f468-200d-1f467'
      },
      {
        ch: '👨‍👧‍👦',
        cp: '1f468-200d-1f467-200d-1f466'
      },
      {
        ch: '👨‍👦‍👦',
        cp: '1f468-200d-1f466-200d-1f466'
      },
      {
        ch: '👨‍👧‍👧',
        cp: '1f468-200d-1f467-200d-1f467'
      },
      {
        ch: '👚',
        cp: '1f45a'
      },
      {
        ch: '👕',
        cp: '1f455'
      },
      {
        ch: '🥼',
        cp: '1f97c'
      },
      {
        ch: '🧥',
        cp: '1f9e5'
      },
      {
        ch: '👖',
        cp: '1f456'
      },
      {
        ch: '👔',
        cp: '1f454'
      },
      {
        ch: '👗',
        cp: '1f457'
      },
      {
        ch: '👙',
        cp: '1f459'
      },
      {
        ch: '👘',
        cp: '1f458'
      },
      {
        ch: '💄',
        cp: '1f484'
      },
      {
        ch: '💋',
        cp: '1f48b'
      },
      {
        ch: '👣',
        cp: '1f463'
      },
      {
        ch: '🧦',
        cp: '1f9e6'
      },
      {
        ch: '👠',
        cp: '1f460'
      },
      {
        ch: '👡',
        cp: '1f461'
      },
      {
        ch: '👢',
        cp: '1f462'
      },
      {
        ch: '🥿',
        cp: '1f97f'
      },
      {
        ch: '👞',
        cp: '1f45e'
      },
      {
        ch: '👟',
        cp: '1f45f'
      },
      {
        ch: '🥾',
        cp: '1f97e'
      },
      {
        ch: '🧢',
        cp: '1f9e2'
      },
      {
        ch: '👒',
        cp: '1f452'
      },
      {
        ch: '🎩',
        cp: '1f3a9'
      },
      {
        ch: '🎓',
        cp: '1f393'
      },
      {
        ch: '👑',
        cp: '1f451'
      },
      {
        ch: '⛑',
        cp: '26d1'
      },
      {
        ch: '🎒',
        cp: '1f392'
      },
      {
        ch: '👝',
        cp: '1f45d'
      },
      {
        ch: '👛',
        cp: '1f45b'
      },
      {
        ch: '👜',
        cp: '1f45c'
      },
      {
        ch: '💼',
        cp: '1f4bc'
      },
      {
        ch: '👓',
        cp: '1f453'
      },
      {
        ch: '🕶',
        cp: '1f576'
      },
      {
        ch: '🥽',
        cp: '1f97d'
      },
      {
        ch: '🧣',
        cp: '1f9e3'
      },
      {
        ch: '🧤',
        cp: '1f9e4'
      },
      {
        ch: '💍',
        cp: '1f48d'
      },
      {
        ch: '🌂',
        cp: '1f302'
      },
      {
        ch: '☂',
        cp: '2602'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.wild',
      fix: 'Animaux et nature',
    },
    icon: {
      ch: '🐼',
      cp: '1f43c'
    },
    emojis: [{
        ch: '🐶',
        cp: '1f436'
      },
      {
        ch: '🐱',
        cp: '1f431'
      },
      {
        ch: '🐭',
        cp: '1f42d'
      },
      {
        ch: '🐹',
        cp: '1f439'
      },
      {
        ch: '🐰',
        cp: '1f430'
      },
      {
        ch: '🐻',
        cp: '1f43b'
      },
      {
        ch: '🧸',
        cp: '1f9f8'
      },
      {
        ch: '🐼',
        cp: '1f43c'
      },
      {
        ch: '🐨',
        cp: '1f428'
      },
      {
        ch: '🐯',
        cp: '1f42f'
      },
      {
        ch: '🦁',
        cp: '1f981'
      },
      {
        ch: '🐮',
        cp: '1f42e'
      },
      {
        ch: '🐷',
        cp: '1f437'
      },
      {
        ch: '🐽',
        cp: '1f43d'
      },
      {
        ch: '🐸',
        cp: '1f438'
      },
      {
        ch: '🐵',
        cp: '1f435'
      },
      {
        ch: '🙈',
        cp: '1f648'
      },
      {
        ch: '🙉',
        cp: '1f649'
      },
      {
        ch: '🙊',
        cp: '1f64a'
      },
      {
        ch: '🐒',
        cp: '1f412'
      },
      {
        ch: '🦍',
        cp: '1f98d'
      },
      {
        ch: '🐔',
        cp: '1f414'
      },
      {
        ch: '🐧',
        cp: '1f427'
      },
      {
        ch: '🐦',
        cp: '1f426'
      },
      {
        ch: '🐤',
        cp: '1f424'
      },
      {
        ch: '🐣',
        cp: '1f423'
      },
      {
        ch: '🐥',
        cp: '1f425'
      },
      {
        ch: '🐺',
        cp: '1f43a'
      },
      {
        ch: '🦊',
        cp: '1f98a'
      },
      {
        ch: '🦝',
        cp: '1f99d'
      },
      {
        ch: '🐗',
        cp: '1f417'
      },
      {
        ch: '🐴',
        cp: '1f434'
      },
      {
        ch: '🦓',
        cp: '1f993'
      },
      {
        ch: '🦒',
        cp: '1f992'
      },
      {
        ch: '🦌',
        cp: '1f98c'
      },
      {
        ch: '🦘',
        cp: '1f998'
      },
      {
        ch: '🦄',
        cp: '1f984'
      },
      {
        ch: '🐝',
        cp: '1f41d'
      },
      {
        ch: '🐛',
        cp: '1f41b'
      },
      {
        ch: '🦋',
        cp: '1f98b'
      },
      {
        ch: '🐌',
        cp: '1f40c'
      },
      {
        ch: '🐞',
        cp: '1f41e'
      },
      {
        ch: '🐜',
        cp: '1f41c'
      },
      {
        ch: '🦗',
        cp: '1f997'
      },
      {
        ch: '🕷',
        cp: '1f577'
      },
      {
        ch: '🕸',
        cp: '1f578'
      },
      {
        ch: '🦂',
        cp: '1f982'
      },
      {
        ch: '🦟',
        cp: '1f99f'
      },
      {
        ch: '🦠',
        cp: '1f9a0'
      },
      {
        ch: '🐢',
        cp: '1f422'
      },
      {
        ch: '🐍',
        cp: '1f40d'
      },
      {
        ch: '🦎',
        cp: '1f98e'
      },
      {
        ch: '🐙',
        cp: '1f419'
      },
      {
        ch: '🦑',
        cp: '1f991'
      },
      {
        ch: '🦞',
        cp: '1f99e'
      },
      {
        ch: '🦀',
        cp: '1f980'
      },
      {
        ch: '🦐',
        cp: '1f990'
      },
      {
        ch: '🐠',
        cp: '1f420'
      },
      {
        ch: '🐟',
        cp: '1f41f'
      },
      {
        ch: '🐡',
        cp: '1f421'
      },
      {
        ch: '🐬',
        cp: '1f42c'
      },
      {
        ch: '🦈',
        cp: '1f988'
      },
      {
        ch: '🐳',
        cp: '1f433'
      },
      {
        ch: '🐋',
        cp: '1f40b'
      },
      {
        ch: '🐊',
        cp: '1f40a'
      },
      {
        ch: '🐆',
        cp: '1f406'
      },
      {
        ch: '🐅',
        cp: '1f405'
      },
      {
        ch: '🐃',
        cp: '1f403'
      },
      {
        ch: '🐂',
        cp: '1f402'
      },
      {
        ch: '🐄',
        cp: '1f404'
      },
      {
        ch: '🐪',
        cp: '1f42a'
      },
      {
        ch: '🐫',
        cp: '1f42b'
      },
      {
        ch: '🦙',
        cp: '1f999'
      },
      {
        ch: '🐘',
        cp: '1f418'
      },
      {
        ch: '🦏',
        cp: '1f98f'
      },
      {
        ch: '🦛',
        cp: '1f99b'
      },
      {
        ch: '🐐',
        cp: '1f410'
      },
      {
        ch: '🐏',
        cp: '1f40f'
      },
      {
        ch: '🐑',
        cp: '1f411'
      },
      {
        ch: '🐎',
        cp: '1f40e'
      },
      {
        ch: '🐖',
        cp: '1f416'
      },
      {
        ch: '🦇',
        cp: '1f987'
      },
      {
        ch: '🐓',
        cp: '1f413'
      },
      {
        ch: '🦃',
        cp: '1f983'
      },
      {
        ch: '🕊',
        cp: '1f54a'
      },
      {
        ch: '🦅',
        cp: '1f985'
      },
      {
        ch: '🦆',
        cp: '1f986'
      },
      {
        ch: '🦢',
        cp: '1f9a2'
      },
      {
        ch: '🦉',
        cp: '1f989'
      },
      {
        ch: '🦚',
        cp: '1f99a'
      },
      {
        ch: '🦜',
        cp: '1f99c'
      },
      {
        ch: '🐕',
        cp: '1f415'
      },
      {
        ch: '🐩',
        cp: '1f429'
      },
      {
        ch: '🐈',
        cp: '1f408'
      },
      {
        ch: '🐇',
        cp: '1f407'
      },
      {
        ch: '🐀',
        cp: '1f400'
      },
      {
        ch: '🐁',
        cp: '1f401'
      },
      {
        ch: '🐿',
        cp: '1f43f'
      },
      {
        ch: '🦡',
        cp: '1f9a1'
      },
      {
        ch: '🦔',
        cp: '1f994'
      },
      {
        ch: '🐾',
        cp: '1f43e'
      },
      {
        ch: '🐉',
        cp: '1f409'
      },
      {
        ch: '🐲',
        cp: '1f432'
      },
      {
        ch: '🦕',
        cp: '1f995'
      },
      {
        ch: '🦖',
        cp: '1f996'
      },
      {
        ch: '🌵',
        cp: '1f335'
      },
      {
        ch: '🎄',
        cp: '1f384'
      },
      {
        ch: '🌲',
        cp: '1f332'
      },
      {
        ch: '🌳',
        cp: '1f333'
      },
      {
        ch: '🌴',
        cp: '1f334'
      },
      {
        ch: '🌱',
        cp: '1f331'
      },
      {
        ch: '🌿',
        cp: '1f33f'
      },
      {
        ch: '☘',
        cp: '2618'
      },
      {
        ch: '🍀',
        cp: '1f340'
      },
      {
        ch: '🎍',
        cp: '1f38d'
      },
      {
        ch: '🎋',
        cp: '1f38b'
      },
      {
        ch: '🍃',
        cp: '1f343'
      },
      {
        ch: '🍂',
        cp: '1f342'
      },
      {
        ch: '🍁',
        cp: '1f341'
      },
      {
        ch: '🌾',
        cp: '1f33e'
      },
      {
        ch: '🌺',
        cp: '1f33a'
      },
      {
        ch: '🌻',
        cp: '1f33b'
      },
      {
        ch: '🌹',
        cp: '1f339'
      },
      {
        ch: '🥀',
        cp: '1f940'
      },
      {
        ch: '🌷',
        cp: '1f337'
      },
      {
        ch: '🌼',
        cp: '1f33c'
      },
      {
        ch: '🌸',
        cp: '1f338'
      },
      {
        ch: '💐',
        cp: '1f490'
      },
      {
        ch: '🍄',
        cp: '1f344'
      },
      {
        ch: '🌰',
        cp: '1f330'
      },
      {
        ch: '🐚',
        cp: '1f41a'
      },
      {
        ch: '🌎',
        cp: '1f30e'
      },
      {
        ch: '🌍',
        cp: '1f30d'
      },
      {
        ch: '🌏',
        cp: '1f30f'
      },
      {
        ch: '🌕',
        cp: '1f315'
      },
      {
        ch: '🌖',
        cp: '1f316'
      },
      {
        ch: '🌗',
        cp: '1f317'
      },
      {
        ch: '🌘',
        cp: '1f318'
      },
      {
        ch: '🌑',
        cp: '1f311'
      },
      {
        ch: '🌒',
        cp: '1f312'
      },
      {
        ch: '🌓',
        cp: '1f313'
      },
      {
        ch: '🌔',
        cp: '1f314'
      },
      {
        ch: '🌚',
        cp: '1f31a'
      },
      {
        ch: '🌝',
        cp: '1f31d'
      },
      {
        ch: '🌛',
        cp: '1f31b'
      },
      {
        ch: '🌜',
        cp: '1f31c'
      },
      {
        ch: '🌞',
        cp: '1f31e'
      },
      {
        ch: '🌙',
        cp: '1f319'
      },
      {
        ch: '⭐',
        cp: '2b50'
      },
      {
        ch: '🌟',
        cp: '1f31f'
      },
      {
        ch: '💫',
        cp: '1f4ab'
      },
      {
        ch: '✨',
        cp: '2728'
      },
      {
        ch: '☄',
        cp: '2604'
      },
      {
        ch: '☀',
        cp: '2600'
      },
      {
        ch: '🌤',
        cp: '1f324'
      },
      {
        ch: '⛅',
        cp: '26c5'
      },
      {
        ch: '🌥',
        cp: '1f325'
      },
      {
        ch: '🌦',
        cp: '1f326'
      },
      {
        ch: '☁',
        cp: '2601'
      },
      {
        ch: '🌧',
        cp: '1f327'
      },
      {
        ch: '⛈',
        cp: '26c8'
      },
      {
        ch: '🌩',
        cp: '1f329'
      },
      {
        ch: '⚡',
        cp: '26a1'
      },
      {
        ch: '🔥',
        cp: '1f525'
      },
      {
        ch: '💥',
        cp: '1f4a5'
      },
      {
        ch: '❄',
        cp: '2744'
      },
      {
        ch: '🌨',
        cp: '1f328'
      },
      {
        ch: '☃',
        cp: '2603'
      },
      {
        ch: '⛄',
        cp: '26c4'
      },
      {
        ch: '🌬',
        cp: '1f32c'
      },
      {
        ch: '💨',
        cp: '1f4a8'
      },
      {
        ch: '🌪',
        cp: '1f32a'
      },
      {
        ch: '🌫',
        cp: '1f32b'
      },
      {
        ch: '☔',
        cp: '2614'
      },
      {
        ch: '💧',
        cp: '1f4a7'
      },
      {
        ch: '💦',
        cp: '1f4a6'
      },
      {
        ch: '🌊',
        cp: '1f30a'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.food',
      fix: 'Nourriture et boisson',
    },
    icon: {
      ch: '🍴',
      cp: '1f374'
    },
    emojis: [{
        ch: '🍏',
        cp: '1f34f'
      },
      {
        ch: '🍎',
        cp: '1f34e'
      },
      {
        ch: '🍐',
        cp: '1f350'
      },
      {
        ch: '🍊',
        cp: '1f34a'
      },
      {
        ch: '🍋',
        cp: '1f34b'
      },
      {
        ch: '🍌',
        cp: '1f34c'
      },
      {
        ch: '🍉',
        cp: '1f349'
      },
      {
        ch: '🍇',
        cp: '1f347'
      },
      {
        ch: '🍓',
        cp: '1f353'
      },
      {
        ch: '🍈',
        cp: '1f348'
      },
      {
        ch: '🍒',
        cp: '1f352'
      },
      {
        ch: '🍑',
        cp: '1f351'
      },
      {
        ch: '🥭',
        cp: '1f96d'
      },
      {
        ch: '🍍',
        cp: '1f34d'
      },
      {
        ch: '🥥',
        cp: '1f965'
      },
      {
        ch: '🥝',
        cp: '1f95d'
      },
      {
        ch: '🍅',
        cp: '1f345'
      },
      {
        ch: '🥑',
        cp: '1f951'
      },
      {
        ch: '🍆',
        cp: '1f346'
      },
      {
        ch: '🌶',
        cp: '1f336'
      },
      {
        ch: '🥒',
        cp: '1f952'
      },
      {
        ch: '🥬',
        cp: '1f96c'
      },
      {
        ch: '🥦',
        cp: '1f966'
      },
      {
        ch: '🌽',
        cp: '1f33d'
      },
      {
        ch: '🥕',
        cp: '1f955'
      },
      {
        ch: '🥗',
        cp: '1f957'
      },
      {
        ch: '🥔',
        cp: '1f954'
      },
      {
        ch: '🍠',
        cp: '1f360'
      },
      {
        ch: '🥜',
        cp: '1f95c'
      },
      {
        ch: '🍯',
        cp: '1f36f'
      },
      {
        ch: '🍞',
        cp: '1f35e'
      },
      {
        ch: '🥐',
        cp: '1f950'
      },
      {
        ch: '🥖',
        cp: '1f956'
      },
      {
        ch: '🥨',
        cp: '1f968'
      },
      {
        ch: '🥯',
        cp: '1f96f'
      },
      {
        ch: '🥞',
        cp: '1f95e'
      },
      {
        ch: '🧀',
        cp: '1f9c0'
      },
      {
        ch: '🍗',
        cp: '1f357'
      },
      {
        ch: '🍖',
        cp: '1f356'
      },
      {
        ch: '🥩',
        cp: '1f969'
      },
      {
        ch: '🍤',
        cp: '1f364'
      },
      {
        ch: '🥚',
        cp: '1f95a'
      },
      {
        ch: '🍳',
        cp: '1f373'
      },
      {
        ch: '🥓',
        cp: '1f953'
      },
      {
        ch: '🍔',
        cp: '1f354'
      },
      {
        ch: '🍟',
        cp: '1f35f'
      },
      {
        ch: '🌭',
        cp: '1f32d'
      },
      {
        ch: '🍕',
        cp: '1f355'
      },
      {
        ch: '🍝',
        cp: '1f35d'
      },
      {
        ch: '🥪',
        cp: '1f96a'
      },
      {
        ch: '🥙',
        cp: '1f959'
      },
      {
        ch: '🌮',
        cp: '1f32e'
      },
      {
        ch: '🌯',
        cp: '1f32f'
      },
      {
        ch: '🍜',
        cp: '1f35c'
      },
      {
        ch: '🥘',
        cp: '1f958'
      },
      {
        ch: '🍲',
        cp: '1f372'
      },
      {
        ch: '🥫',
        cp: '1f96b'
      },
      {
        ch: '🧂',
        cp: '1f9c2'
      },
      {
        ch: '🍥',
        cp: '1f365'
      },
      {
        ch: '🍣',
        cp: '1f363'
      },
      {
        ch: '🍱',
        cp: '1f371'
      },
      {
        ch: '🍛',
        cp: '1f35b'
      },
      {
        ch: '🍙',
        cp: '1f359'
      },
      {
        ch: '🍚',
        cp: '1f35a'
      },
      {
        ch: '🍘',
        cp: '1f358'
      },
      {
        ch: '🥟',
        cp: '1f95f'
      },
      {
        ch: '🍢',
        cp: '1f362'
      },
      {
        ch: '🍡',
        cp: '1f361'
      },
      {
        ch: '🍧',
        cp: '1f367'
      },
      {
        ch: '🍨',
        cp: '1f368'
      },
      {
        ch: '🍦',
        cp: '1f366'
      },
      {
        ch: '🍰',
        cp: '1f370'
      },
      {
        ch: '🎂',
        cp: '1f382'
      },
      {
        ch: '🧁',
        cp: '1f9c1'
      },
      {
        ch: '🥧',
        cp: '1f967'
      },
      {
        ch: '🍮',
        cp: '1f36e'
      },
      {
        ch: '🍭',
        cp: '1f36d'
      },
      {
        ch: '🍬',
        cp: '1f36c'
      },
      {
        ch: '🍫',
        cp: '1f36b'
      },
      {
        ch: '🍿',
        cp: '1f37f'
      },
      {
        ch: '🍩',
        cp: '1f369'
      },
      {
        ch: '🍪',
        cp: '1f36a'
      },
      {
        ch: '🥠',
        cp: '1f960'
      },
      {
        ch: '🥮',
        cp: '1f96e'
      },
      {
        ch: '☕',
        cp: '2615'
      },
      {
        ch: '🍵',
        cp: '1f375'
      },
      {
        ch: '🥣',
        cp: '1f963'
      },
      {
        ch: '🍼',
        cp: '1f37c'
      },
      {
        ch: '🥤',
        cp: '1f964'
      },
      {
        ch: '🥛',
        cp: '1f95b'
      },
      {
        ch: '🍺',
        cp: '1f37a'
      },
      {
        ch: '🍻',
        cp: '1f37b'
      },
      {
        ch: '🍷',
        cp: '1f377'
      },
      {
        ch: '🥂',
        cp: '1f942'
      },
      {
        ch: '🥃',
        cp: '1f943'
      },
      {
        ch: '🍸',
        cp: '1f378'
      },
      {
        ch: '🍹',
        cp: '1f379'
      },
      {
        ch: '🍾',
        cp: '1f37e'
      },
      {
        ch: '🍶',
        cp: '1f376'
      },
      {
        ch: '🥄',
        cp: '1f944'
      },
      {
        ch: '🍴',
        cp: '1f374'
      },
      {
        ch: '🍽',
        cp: '1f37d'
      },
      {
        ch: '🥢',
        cp: '1f962'
      },
      {
        ch: '🥡',
        cp: '1f961'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.hobbies',
      fix: 'Activité'
    },
    icon: {
      ch: '⚽',
      cp: '26bd'
    },
    emojis: [{
        ch: '⚽',
        cp: '26bd'
      },
      {
        ch: '🏀',
        cp: '1f3c0'
      },
      {
        ch: '🏈',
        cp: '1f3c8'
      },
      {
        ch: '⚾',
        cp: '26be'
      },
      {
        ch: '🥎',
        cp: '1f94e'
      },
      {
        ch: '🎾',
        cp: '1f3be'
      },
      {
        ch: '🏐',
        cp: '1f3d0'
      },
      {
        ch: '🏉',
        cp: '1f3c9'
      },
      {
        ch: '🎱',
        cp: '1f3b1'
      },
      {
        ch: '🥏',
        cp: '1f94f'
      },
      {
        ch: '🏓',
        cp: '1f3d3'
      },
      {
        ch: '🏸',
        cp: '1f3f8'
      },
      {
        ch: '🥅',
        cp: '1f945'
      },
      {
        ch: '🏒',
        cp: '1f3d2'
      },
      {
        ch: '🏑',
        cp: '1f3d1'
      },
      {
        ch: '🏏',
        cp: '1f3cf'
      },
      {
        ch: '🥍',
        cp: '1f94d'
      },
      {
        ch: '🥌',
        cp: '1f94c'
      },
      {
        ch: '⛳',
        cp: '26f3'
      },
      {
        ch: '🏹',
        cp: '1f3f9'
      },
      {
        ch: '🎣',
        cp: '1f3a3'
      },
      {
        ch: '🥊',
        cp: '1f94a'
      },
      {
        ch: '🥋',
        cp: '1f94b'
      },
      {
        ch: '⛸',
        cp: '26f8'
      },
      {
        ch: '🎿',
        cp: '1f3bf'
      },
      {
        ch: '🛷',
        cp: '1f6f7'
      },
      {
        ch: '⛷',
        cp: '26f7'
      },
      {
        ch: '🏂',
        cp: '1f3c2'
      },
      {
        ch: '🏋️‍♀️',
        cp: '1f3cb-fe0f-200d-2640-fe0f'
      },
      {
        ch: '🏋️‍♂️',
        cp: '1f3cb-fe0f-200d-2642-fe0f'
      },
      {
        ch: '🤺',
        cp: '1f93a'
      },
      {
        ch: '🤼‍♀️',
        cp: '1f93c-200d-2640-fe0f'
      },
      {
        ch: '🤼‍♂️',
        cp: '1f93c-200d-2642-fe0f'
      },
      {
        ch: '🤸‍♀️',
        cp: '1f938-200d-2640-fe0f'
      },
      {
        ch: '🤸‍♂️',
        cp: '1f938-200d-2642-fe0f'
      },
      {
        ch: '⛹️‍♀️',
        cp: '26f9-fe0f-200d-2640-fe0f'
      },
      {
        ch: '⛹️‍♂️',
        cp: '26f9-fe0f-200d-2642-fe0f'
      },
      {
        ch: '🤾‍♀️',
        cp: '1f93e-200d-2640-fe0f'
      },
      {
        ch: '🤾‍♂️',
        cp: '1f93e-200d-2642-fe0f'
      },
      {
        ch: '🧗‍♀️',
        cp: '1f9d7-200d-2640-fe0f'
      },
      {
        ch: '🧗‍♂️',
        cp: '1f9d7-200d-2642-fe0f'
      },
      {
        ch: '🏌️‍♀️',
        cp: '1f3cc-fe0f-200d-2640-fe0f'
      },
      {
        ch: '🏌️‍♂️',
        cp: '1f3cc-fe0f-200d-2642-fe0f'
      },
      {
        ch: '🧘‍♀️',
        cp: '1f9d8-200d-2640-fe0f'
      },
      {
        ch: '🧘‍♂️',
        cp: '1f9d8-200d-2642-fe0f'
      },
      {
        ch: '🧖‍♀️',
        cp: '1f9d6-200d-2640-fe0f'
      },
      {
        ch: '🧖‍♂️',
        cp: '1f9d6-200d-2642-fe0f'
      },
      {
        ch: '🏄‍♀️',
        cp: '1f3c4-200d-2640-fe0f'
      },
      {
        ch: '🏄‍♂️',
        cp: '1f3c4-200d-2642-fe0f'
      },
      {
        ch: '🏊‍♀️',
        cp: '1f3ca-200d-2640-fe0f'
      },
      {
        ch: '🏊‍♂️',
        cp: '1f3ca-200d-2642-fe0f'
      },
      {
        ch: '🤽‍♀️',
        cp: '1f93d-200d-2640-fe0f'
      },
      {
        ch: '🤽‍♂️',
        cp: '1f93d-200d-2642-fe0f'
      },
      {
        ch: '🚣‍♀️',
        cp: '1f6a3-200d-2640-fe0f'
      },
      {
        ch: '🚣‍♂️',
        cp: '1f6a3-200d-2642-fe0f'
      },
      {
        ch: '🏇',
        cp: '1f3c7'
      },
      {
        ch: '🚴‍♀️',
        cp: '1f6b4-200d-2640-fe0f'
      },
      {
        ch: '🚴‍♂️',
        cp: '1f6b4-200d-2642-fe0f'
      },
      {
        ch: '🚵‍♀️',
        cp: '1f6b5-200d-2640-fe0f'
      },
      {
        ch: '🚵‍♂️',
        cp: '1f6b5-200d-2642-fe0f'
      },
      {
        ch: '🎽',
        cp: '1f3bd'
      },
      {
        ch: '🎖',
        cp: '1f396'
      },
      {
        ch: '🏅',
        cp: '1f3c5'
      },
      {
        ch: '🥇',
        cp: '1f947'
      },
      {
        ch: '🥈',
        cp: '1f948'
      },
      {
        ch: '🥉',
        cp: '1f949'
      },
      {
        ch: '🏆',
        cp: '1f3c6'
      },
      {
        ch: '🏵',
        cp: '1f3f5'
      },
      {
        ch: '🎗',
        cp: '1f397'
      },
      {
        ch: '🎫',
        cp: '1f3ab'
      },
      {
        ch: '🎟',
        cp: '1f39f'
      },
      {
        ch: '🎪',
        cp: '1f3aa'
      },
      {
        ch: '🤹‍♀️',
        cp: '1f939-200d-2640-fe0f'
      },
      {
        ch: '🤹‍♂️',
        cp: '1f939-200d-2642-fe0f'
      },
      {
        ch: '🎭',
        cp: '1f3ad'
      },
      {
        ch: '🎨',
        cp: '1f3a8'
      },
      {
        ch: '🎬',
        cp: '1f3ac'
      },
      {
        ch: '🎤',
        cp: '1f3a4'
      },
      {
        ch: '🎧',
        cp: '1f3a7'
      },
      {
        ch: '🎼',
        cp: '1f3bc'
      },
      {
        ch: '🎹',
        cp: '1f3b9'
      },
      {
        ch: '🥁',
        cp: '1f941'
      },
      {
        ch: '🎷',
        cp: '1f3b7'
      },
      {
        ch: '🎺',
        cp: '1f3ba'
      },
      {
        ch: '🎸',
        cp: '1f3b8'
      },
      {
        ch: '🎻',
        cp: '1f3bb'
      },
      {
        ch: '🎲',
        cp: '1f3b2'
      },
      {
        ch: '🧩',
        cp: '1f9e9'
      },
      {
        ch: '♟️',
        cp: '265f'
      },
      {
        ch: '🎯',
        cp: '1f3af'
      },
      {
        ch: '🎳',
        cp: '1f3b3'
      },
      {
        ch: '🎮',
        cp: '1f3ae'
      },
      {
        ch: '👾',
        cp: '1f47e'
      },
      {
        ch: '🎰',
        cp: '1f3b0'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.travels',
      fix: 'Voyages et lieux'
    },
    icon: {
      ch: '🚘',
      cp: '1f698'
    },
    emojis: [{
        ch: '🚗',
        cp: '1f697'
      },
      {
        ch: '🚕',
        cp: '1f695'
      },
      {
        ch: '🚙',
        cp: '1f699'
      },
      {
        ch: '🚌',
        cp: '1f68c'
      },
      {
        ch: '🚎',
        cp: '1f68e'
      },
      {
        ch: '🏎',
        cp: '1f3ce'
      },
      {
        ch: '🚓',
        cp: '1f693'
      },
      {
        ch: '🚑',
        cp: '1f691'
      },
      {
        ch: '🚒',
        cp: '1f692'
      },
      {
        ch: '🚐',
        cp: '1f690'
      },
      {
        ch: '🚚',
        cp: '1f69a'
      },
      {
        ch: '🚛',
        cp: '1f69b'
      },
      {
        ch: '🚜',
        cp: '1f69c'
      },
      {
        ch: '🏍',
        cp: '1f3cd'
      },
      {
        ch: '🛵',
        cp: '1f6f5'
      },
      {
        ch: '🚲',
        cp: '1f6b2'
      },
      {
        ch: '🛴',
        cp: '1f6f4'
      },
      {
        ch: '🛹',
        cp: '1f6f9'
      },
      {
        ch: '🚨',
        cp: '1f6a8'
      },
      {
        ch: '🚔',
        cp: '1f694'
      },
      {
        ch: '🚍',
        cp: '1f68d'
      },
      {
        ch: '🚘',
        cp: '1f698'
      },
      {
        ch: '🚖',
        cp: '1f696'
      },
      {
        ch: '🚡',
        cp: '1f6a1'
      },
      {
        ch: '🚠',
        cp: '1f6a0'
      },
      {
        ch: '🚟',
        cp: '1f69f'
      },
      {
        ch: '🚃',
        cp: '1f683'
      },
      {
        ch: '🚋',
        cp: '1f68b'
      },
      {
        ch: '🚝',
        cp: '1f69d'
      },
      {
        ch: '🚄',
        cp: '1f684'
      },
      {
        ch: '🚅',
        cp: '1f685'
      },
      {
        ch: '🚈',
        cp: '1f688'
      },
      {
        ch: '🚞',
        cp: '1f69e'
      },
      {
        ch: '🚂',
        cp: '1f682'
      },
      {
        ch: '🚆',
        cp: '1f686'
      },
      {
        ch: '🚇',
        cp: '1f687'
      },
      {
        ch: '🚊',
        cp: '1f68a'
      },
      {
        ch: '🚉',
        cp: '1f689'
      },
      {
        ch: '🚁',
        cp: '1f681'
      },
      {
        ch: '🛩',
        cp: '1f6e9'
      },
      {
        ch: '✈',
        cp: '2708'
      },
      {
        ch: '🛫',
        cp: '1f6eb'
      },
      {
        ch: '🛬',
        cp: '1f6ec'
      },
      {
        ch: '🛶',
        cp: '1f6f6'
      },
      {
        ch: '⛵',
        cp: '26f5'
      },
      {
        ch: '🛥',
        cp: '1f6e5'
      },
      {
        ch: '🚤',
        cp: '1f6a4'
      },
      {
        ch: '⛴',
        cp: '26f4'
      },
      {
        ch: '🛳',
        cp: '1f6f3'
      },
      {
        ch: '🚀',
        cp: '1f680'
      },
      {
        ch: '🛸',
        cp: '1f6f8'
      },
      {
        ch: '🛰',
        cp: '1f6f0'
      },
      {
        ch: '💺',
        cp: '1f4ba'
      },
      {
        ch: '⚓',
        cp: '2693'
      },
      {
        ch: '🚧',
        cp: '1f6a7'
      },
      {
        ch: '⛽',
        cp: '26fd'
      },
      {
        ch: '🚏',
        cp: '1f68f'
      },
      {
        ch: '🚦',
        cp: '1f6a6'
      },
      {
        ch: '🚥',
        cp: '1f6a5'
      },
      {
        ch: '🛑',
        cp: '1f6d1'
      },
      {
        ch: '🚢',
        cp: '1f6a2'
      },
      {
        ch: '🎡',
        cp: '1f3a1'
      },
      {
        ch: '🎢',
        cp: '1f3a2'
      },
      {
        ch: '🎠',
        cp: '1f3a0'
      },
      {
        ch: '🏗',
        cp: '1f3d7'
      },
      {
        ch: '🌁',
        cp: '1f301'
      },
      {
        ch: '🗼',
        cp: '1f5fc'
      },
      {
        ch: '🏭',
        cp: '1f3ed'
      },
      {
        ch: '⛲',
        cp: '26f2'
      },
      {
        ch: '🎑',
        cp: '1f391'
      },
      {
        ch: '⛰',
        cp: '26f0'
      },
      {
        ch: '🏔',
        cp: '1f3d4'
      },
      {
        ch: '🗻',
        cp: '1f5fb'
      },
      {
        ch: '🌋',
        cp: '1f30b'
      },
      {
        ch: '🗾',
        cp: '1f5fe'
      },
      {
        ch: '🏕',
        cp: '1f3d5'
      },
      {
        ch: '⛺',
        cp: '26fa'
      },
      {
        ch: '🏞',
        cp: '1f3de'
      },
      {
        ch: '🛣',
        cp: '1f6e3'
      },
      {
        ch: '🛤',
        cp: '1f6e4'
      },
      {
        ch: '🌅',
        cp: '1f305'
      },
      {
        ch: '🌄',
        cp: '1f304'
      },
      {
        ch: '🏜',
        cp: '1f3dc'
      },
      {
        ch: '🏖',
        cp: '1f3d6'
      },
      {
        ch: '🏝',
        cp: '1f3dd'
      },
      {
        ch: '🌇',
        cp: '1f307'
      },
      {
        ch: '🌆',
        cp: '1f306'
      },
      {
        ch: '🏙',
        cp: '1f3d9'
      },
      {
        ch: '🌃',
        cp: '1f303'
      },
      {
        ch: '🌉',
        cp: '1f309'
      },
      {
        ch: '🌌',
        cp: '1f30c'
      },
      {
        ch: '🌠',
        cp: '1f320'
      },
      {
        ch: '🎇',
        cp: '1f387'
      },
      {
        ch: '🎆',
        cp: '1f386'
      },
      {
        ch: '🌈',
        cp: '1f308'
      },
      {
        ch: '🏘',
        cp: '1f3d8'
      },
      {
        ch: '🏰',
        cp: '1f3f0'
      },
      {
        ch: '🏯',
        cp: '1f3ef'
      },
      {
        ch: '🏟',
        cp: '1f3df'
      },
      {
        ch: '🗽',
        cp: '1f5fd'
      },
      {
        ch: '🏠',
        cp: '1f3e0'
      },
      {
        ch: '🏡',
        cp: '1f3e1'
      },
      {
        ch: '🏚',
        cp: '1f3da'
      },
      {
        ch: '🏢',
        cp: '1f3e2'
      },
      {
        ch: '🏬',
        cp: '1f3ec'
      },
      {
        ch: '🏣',
        cp: '1f3e3'
      },
      {
        ch: '🏤',
        cp: '1f3e4'
      },
      {
        ch: '🏥',
        cp: '1f3e5'
      },
      {
        ch: '🏦',
        cp: '1f3e6'
      },
      {
        ch: '🏨',
        cp: '1f3e8'
      },
      {
        ch: '🏪',
        cp: '1f3ea'
      },
      {
        ch: '🏫',
        cp: '1f3eb'
      },
      {
        ch: '🏩',
        cp: '1f3e9'
      },
      {
        ch: '💒',
        cp: '1f492'
      },
      {
        ch: '🏛',
        cp: '1f3db'
      },
      {
        ch: '⛪',
        cp: '26ea'
      },
      {
        ch: '🕌',
        cp: '1f54c'
      },
      {
        ch: '🕍',
        cp: '1f54d'
      },
      {
        ch: '🕋',
        cp: '1f54b'
      },
      {
        ch: '⛩',
        cp: '26e9'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.objects',
      fix: 'Objets'
    },
    icon: {
      ch: '💡',
      cp: '1f4a1'
    },
    emojis: [{
        ch: '⌚',
        cp: '231a'
      },
      {
        ch: '📱',
        cp: '1f4f1'
      },
      {
        ch: '📲',
        cp: '1f4f2'
      },
      {
        ch: '💻',
        cp: '1f4bb'
      },
      {
        ch: '⌨',
        cp: '2328'
      },
      {
        ch: '🖥',
        cp: '1f5a5'
      },
      {
        ch: '🖨',
        cp: '1f5a8'
      },
      {
        ch: '🖱',
        cp: '1f5b1'
      },
      {
        ch: '🖲',
        cp: '1f5b2'
      },
      {
        ch: '🕹',
        cp: '1f579'
      },
      {
        ch: '🗜',
        cp: '1f5dc'
      },
      {
        ch: '💽',
        cp: '1f4bd'
      },
      {
        ch: '💾',
        cp: '1f4be'
      },
      {
        ch: '💿',
        cp: '1f4bf'
      },
      {
        ch: '📀',
        cp: '1f4c0'
      },
      {
        ch: '📼',
        cp: '1f4fc'
      },
      {
        ch: '📷',
        cp: '1f4f7'
      },
      {
        ch: '📸',
        cp: '1f4f8'
      },
      {
        ch: '📹',
        cp: '1f4f9'
      },
      {
        ch: '🎥',
        cp: '1f3a5'
      },
      {
        ch: '📽',
        cp: '1f4fd'
      },
      {
        ch: '🎞',
        cp: '1f39e'
      },
      {
        ch: '📞',
        cp: '1f4de'
      },
      {
        ch: '☎',
        cp: '260e'
      },
      {
        ch: '📟',
        cp: '1f4df'
      },
      {
        ch: '📠',
        cp: '1f4e0'
      },
      {
        ch: '📺',
        cp: '1f4fa'
      },
      {
        ch: '📻',
        cp: '1f4fb'
      },
      {
        ch: '🎙',
        cp: '1f399'
      },
      {
        ch: '🎚',
        cp: '1f39a'
      },
      {
        ch: '🎛',
        cp: '1f39b'
      },
      {
        ch: '⏱',
        cp: '23f1'
      },
      {
        ch: '⏲',
        cp: '23f2'
      },
      {
        ch: '⏰',
        cp: '23f0'
      },
      {
        ch: '🕰',
        cp: '1f570'
      },
      {
        ch: '⏳',
        cp: '23f3'
      },
      {
        ch: '⌛',
        cp: '231b'
      },
      {
        ch: '🧮',
        cp: '1f9ee'
      },
      {
        ch: '📡',
        cp: '1f4e1'
      },
      {
        ch: '🔋',
        cp: '1f50b'
      },
      {
        ch: '🔌',
        cp: '1f50c'
      },
      {
        ch: '💡',
        cp: '1f4a1'
      },
      {
        ch: '🔦',
        cp: '1f526'
      },
      {
        ch: '🕯',
        cp: '1f56f'
      },
      {
        ch: '🧯',
        cp: '1f9ef'
      },
      {
        ch: '🗑',
        cp: '1f5d1'
      },
      {
        ch: '🛢',
        cp: '1f6e2'
      },
      {
        ch: '🛒',
        cp: '1f6d2'
      },
      {
        ch: '💸',
        cp: '1f4b8'
      },
      {
        ch: '💵',
        cp: '1f4b5'
      },
      {
        ch: '💴',
        cp: '1f4b4'
      },
      {
        ch: '💶',
        cp: '1f4b6'
      },
      {
        ch: '💷',
        cp: '1f4b7'
      },
      {
        ch: '💰',
        cp: '1f4b0'
      },
      {
        ch: '💳',
        cp: '1f4b3'
      },
      {
        ch: '🧾',
        cp: '1f9fe'
      },
      {
        ch: '💎',
        cp: '1f48e'
      },
      {
        ch: '⚖',
        cp: '2696'
      },
      {
        ch: '🧰',
        cp: '1f9f0'
      },
      {
        ch: '🔧',
        cp: '1f527'
      },
      {
        ch: '🔨',
        cp: '1f528'
      },
      {
        ch: '⚒',
        cp: '2692'
      },
      {
        ch: '🛠',
        cp: '1f6e0'
      },
      {
        ch: '⛏',
        cp: '26cf'
      },
      {
        ch: '🔩',
        cp: '1f529'
      },
      {
        ch: '⚙',
        cp: '2699'
      },
      {
        ch: '⛓',
        cp: '26d3'
      },
      {
        ch: '🧱',
        cp: '1f9f1'
      },
      {
        ch: '🔫',
        cp: '1f52b'
      },
      {
        ch: '🧨',
        cp: '1f9e8'
      },
      {
        ch: '💣',
        cp: '1f4a3'
      },
      {
        ch: '🔪',
        cp: '1f52a'
      },
      {
        ch: '🗡',
        cp: '1f5e1'
      },
      {
        ch: '⚔',
        cp: '2694'
      },
      {
        ch: '🛡',
        cp: '1f6e1'
      },
      {
        ch: '🚬',
        cp: '1f6ac'
      },
      {
        ch: '⚰',
        cp: '26b0'
      },
      {
        ch: '⚱',
        cp: '26b1'
      },
      {
        ch: '🏺',
        cp: '1f3fa'
      },
      {
        ch: '🔮',
        cp: '1f52e'
      },
      {
        ch: '📿',
        cp: '1f4ff'
      },
      {
        ch: '🧿',
        cp: '1f9ff'
      },
      {
        ch: '💈',
        cp: '1f488'
      },
      {
        ch: '🧲',
        cp: '1f9f2'
      },
      {
        ch: '⚗',
        cp: '2697'
      },
      {
        ch: '🧪',
        cp: '1f9ea'
      },
      {
        ch: '🧫',
        cp: '1f9eb'
      },
      {
        ch: '🧬',
        cp: '1f9ec'
      },
      {
        ch: '🔭',
        cp: '1f52d'
      },
      {
        ch: '🔬',
        cp: '1f52c'
      },
      {
        ch: '🕳',
        cp: '1f573'
      },
      {
        ch: '💊',
        cp: '1f48a'
      },
      {
        ch: '💉',
        cp: '1f489'
      },
      {
        ch: '🌡',
        cp: '1f321'
      },
      {
        ch: '🏷',
        cp: '1f3f7'
      },
      {
        ch: '🔖',
        cp: '1f516'
      },
      {
        ch: '🚽',
        cp: '1f6bd'
      },
      {
        ch: '🚿',
        cp: '1f6bf'
      },
      {
        ch: '🛁',
        cp: '1f6c1'
      },
      {
        ch: '🛀',
        cp: '1f6c0'
      },
      {
        ch: '🧴',
        cp: '1f9f4'
      },
      {
        ch: '🧹',
        cp: '1f9f9'
      },
      {
        ch: '🧺',
        cp: '1f9fa'
      },
      {
        ch: '🧻',
        cp: '1f9fb'
      },
      {
        ch: '🧼',
        cp: '1f9fc'
      },
      {
        ch: '🧽',
        cp: '1f9fd'
      },
      {
        ch: '🔑',
        cp: '1f511'
      },
      {
        ch: '🗝',
        cp: '1f5dd'
      },
      {
        ch: '🛋',
        cp: '1f6cb'
      },
      {
        ch: '🛌',
        cp: '1f6cc'
      },
      {
        ch: '🛏',
        cp: '1f6cf'
      },
      {
        ch: '🚪',
        cp: '1f6aa'
      },
      {
        ch: '🧳',
        cp: '1f9f3'
      },
      {
        ch: '🛎',
        cp: '1f6ce'
      },
      {
        ch: '🖼',
        cp: '1f5bc'
      },
      {
        ch: '🧭',
        cp: '1f9ed'
      },
      {
        ch: '🗺',
        cp: '1f5fa'
      },
      {
        ch: '⛱',
        cp: '26f1'
      },
      {
        ch: '🗿',
        cp: '1f5ff'
      },
      {
        ch: '🛍',
        cp: '1f6cd'
      },
      {
        ch: '🎈',
        cp: '1f388'
      },
      {
        ch: '🎏',
        cp: '1f38f'
      },
      {
        ch: '🎀',
        cp: '1f380'
      },
      {
        ch: '🧧',
        cp: '1f9e7'
      },
      {
        ch: '🎁',
        cp: '1f381'
      },
      {
        ch: '🎊',
        cp: '1f38a'
      },
      {
        ch: '🎉',
        cp: '1f389'
      },
      {
        ch: '🎎',
        cp: '1f38e'
      },
      {
        ch: '🎐',
        cp: '1f390'
      },
      {
        ch: '🏮',
        cp: '1f3ee'
      },
      {
        ch: '✉',
        cp: '2709'
      },
      {
        ch: '📩',
        cp: '1f4e9'
      },
      {
        ch: '📨',
        cp: '1f4e8'
      },
      {
        ch: '📧',
        cp: '1f4e7'
      },
      {
        ch: '💌',
        cp: '1f48c'
      },
      {
        ch: '📮',
        cp: '1f4ee'
      },
      {
        ch: '📪',
        cp: '1f4ea'
      },
      {
        ch: '📫',
        cp: '1f4eb'
      },
      {
        ch: '📬',
        cp: '1f4ec'
      },
      {
        ch: '📭',
        cp: '1f4ed'
      },
      {
        ch: '📦',
        cp: '1f4e6'
      },
      {
        ch: '📯',
        cp: '1f4ef'
      },
      {
        ch: '📥',
        cp: '1f4e5'
      },
      {
        ch: '📤',
        cp: '1f4e4'
      },
      {
        ch: '📜',
        cp: '1f4dc'
      },
      {
        ch: '📃',
        cp: '1f4c3'
      },
      {
        ch: '📑',
        cp: '1f4d1'
      },
      {
        ch: '📊',
        cp: '1f4ca'
      },
      {
        ch: '📈',
        cp: '1f4c8'
      },
      {
        ch: '📉',
        cp: '1f4c9'
      },
      {
        ch: '📄',
        cp: '1f4c4'
      },
      {
        ch: '📅',
        cp: '1f4c5'
      },
      {
        ch: '📆',
        cp: '1f4c6'
      },
      {
        ch: '🗓',
        cp: '1f5d3'
      },
      {
        ch: '📇',
        cp: '1f4c7'
      },
      {
        ch: '🗃',
        cp: '1f5c3'
      },
      {
        ch: '🗳',
        cp: '1f5f3'
      },
      {
        ch: '🗄',
        cp: '1f5c4'
      },
      {
        ch: '📋',
        cp: '1f4cb'
      },
      {
        ch: '🗒',
        cp: '1f5d2'
      },
      {
        ch: '📁',
        cp: '1f4c1'
      },
      {
        ch: '📂',
        cp: '1f4c2'
      },
      {
        ch: '🗂',
        cp: '1f5c2'
      },
      {
        ch: '🗞',
        cp: '1f5de'
      },
      {
        ch: '📰',
        cp: '1f4f0'
      },
      {
        ch: '📓',
        cp: '1f4d3'
      },
      {
        ch: '📕',
        cp: '1f4d5'
      },
      {
        ch: '📗',
        cp: '1f4d7'
      },
      {
        ch: '📘',
        cp: '1f4d8'
      },
      {
        ch: '📙',
        cp: '1f4d9'
      },
      {
        ch: '📔',
        cp: '1f4d4'
      },
      {
        ch: '📒',
        cp: '1f4d2'
      },
      {
        ch: '📚',
        cp: '1f4da'
      },
      {
        ch: '📖',
        cp: '1f4d6'
      },
      {
        ch: '🔗',
        cp: '1f517'
      },
      {
        ch: '📎',
        cp: '1f4ce'
      },
      {
        ch: '🖇',
        cp: '1f587'
      },
      {
        ch: '✂',
        cp: '2702'
      },
      {
        ch: '📐',
        cp: '1f4d0'
      },
      {
        ch: '📏',
        cp: '1f4cf'
      },
      {
        ch: '📌',
        cp: '1f4cc'
      },
      {
        ch: '📍',
        cp: '1f4cd'
      },
      {
        ch: '🧷',
        cp: '1f9f7'
      },
      {
        ch: '🧵',
        cp: '1f9f5'
      },
      {
        ch: '🧶',
        cp: '1f9f6'
      },
      {
        ch: '🔐',
        cp: '1f510'
      },
      {
        ch: '🔒',
        cp: '1f512'
      },
      {
        ch: '🔓',
        cp: '1f513'
      },
      {
        ch: '🔏',
        cp: '1f50f'
      },
      {
        ch: '🖊',
        cp: '1f58a'
      },
      {
        ch: '🖋',
        cp: '1f58b'
      },
      {
        ch: '✒',
        cp: '2712'
      },
      {
        ch: '📝',
        cp: '1f4dd'
      },
      {
        ch: '✏',
        cp: '270f'
      },
      {
        ch: '🖍',
        cp: '1f58d'
      },
      {
        ch: '🖌',
        cp: '1f58c'
      },
      {
        ch: '🔍',
        cp: '1f50d'
      },
      {
        ch: '🔎',
        cp: '1f50e'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.symbols',
      fix: 'Symboles'
    },
    icon: {
      ch: '⁉',
      cp: '2049'
    },
    emojis: [{
        ch: '❤',
        cp: '2764'
      },
      {
        ch: '🧡',
        cp: '1f9e1'
      },
      {
        ch: '💛',
        cp: '1f49b'
      },
      {
        ch: '💚',
        cp: '1f49a'
      },
      {
        ch: '💙',
        cp: '1f499'
      },
      {
        ch: '💜',
        cp: '1f49c'
      },
      {
        ch: '🖤',
        cp: '1f5a4'
      },
      {
        ch: '💔',
        cp: '1f494'
      },
      {
        ch: '❣',
        cp: '2763'
      },
      {
        ch: '💕',
        cp: '1f495'
      },
      {
        ch: '💞',
        cp: '1f49e'
      },
      {
        ch: '💓',
        cp: '1f493'
      },
      {
        ch: '💗',
        cp: '1f497'
      },
      {
        ch: '💖',
        cp: '1f496'
      },
      {
        ch: '💘',
        cp: '1f498'
      },
      {
        ch: '💝',
        cp: '1f49d'
      },
      {
        ch: '💟',
        cp: '1f49f'
      },
      {
        ch: '☮',
        cp: '262e'
      },
      {
        ch: '✝',
        cp: '271d'
      },
      {
        ch: '☪',
        cp: '262a'
      },
      {
        ch: '🕉',
        cp: '1f549'
      },
      {
        ch: '☸',
        cp: '2638'
      },
      {
        ch: '✡',
        cp: '2721'
      },
      {
        ch: '🔯',
        cp: '1f52f'
      },
      {
        ch: '🕎',
        cp: '1f54e'
      },
      {
        ch: '☯',
        cp: '262f'
      },
      {
        ch: '☦',
        cp: '2626'
      },
      {
        ch: '🛐',
        cp: '1f6d0'
      },
      {
        ch: '⛎',
        cp: '26ce'
      },
      {
        ch: '♈',
        cp: '2648'
      },
      {
        ch: '♉',
        cp: '2649'
      },
      {
        ch: '♊',
        cp: '264a'
      },
      {
        ch: '♋',
        cp: '264b'
      },
      {
        ch: '♌',
        cp: '264c'
      },
      {
        ch: '♍',
        cp: '264d'
      },
      {
        ch: '♎',
        cp: '264e'
      },
      {
        ch: '♏',
        cp: '264f'
      },
      {
        ch: '♐',
        cp: '2650'
      },
      {
        ch: '♑',
        cp: '2651'
      },
      {
        ch: '♒',
        cp: '2652'
      },
      {
        ch: '♓',
        cp: '2653'
      },
      {
        ch: '🆔',
        cp: '1f194'
      },
      {
        ch: '⚛',
        cp: '269b'
      },
      {
        ch: '⚕',
        cp: '2695'
      },
      {
        ch: '☢',
        cp: '2622'
      },
      {
        ch: '☣',
        cp: '2623'
      },
      {
        ch: '📴',
        cp: '1f4f4'
      },
      {
        ch: '📳',
        cp: '1f4f3'
      },
      {
        ch: '🈶',
        cp: '1f236'
      },
      {
        ch: '🈚',
        cp: '1f21a'
      },
      {
        ch: '🈸',
        cp: '1f238'
      },
      {
        ch: '🈺',
        cp: '1f23a'
      },
      {
        ch: '🈷',
        cp: '1f237'
      },
      {
        ch: '✴',
        cp: '2734'
      },
      {
        ch: '🆚',
        cp: '1f19a'
      },
      {
        ch: '🉑',
        cp: '1f251'
      },
      {
        ch: '💮',
        cp: '1f4ae'
      },
      {
        ch: '🉐',
        cp: '1f250'
      },
      {
        ch: '㊙',
        cp: '3299'
      },
      {
        ch: '㊗',
        cp: '3297'
      },
      {
        ch: '🈴',
        cp: '1f234'
      },
      {
        ch: '🈵',
        cp: '1f235'
      },
      {
        ch: '🈹',
        cp: '1f239'
      },
      {
        ch: '🈲',
        cp: '1f232'
      },
      {
        ch: '🅰',
        cp: '1f170'
      },
      {
        ch: '🅱',
        cp: '1f171'
      },
      {
        ch: '🆎',
        cp: '1f18e'
      },
      {
        ch: '🆑',
        cp: '1f191'
      },
      {
        ch: '🅾',
        cp: '1f17e'
      },
      {
        ch: '🆘',
        cp: '1f198'
      },
      {
        ch: '⛔',
        cp: '26d4'
      },
      {
        ch: '📛',
        cp: '1f4db'
      },
      {
        ch: '🚫',
        cp: '1f6ab'
      },
      {
        ch: '❌',
        cp: '274c'
      },
      {
        ch: '⭕',
        cp: '2b55'
      },
      {
        ch: '💢',
        cp: '1f4a2'
      },
      {
        ch: '♨',
        cp: '2668'
      },
      {
        ch: '🚷',
        cp: '1f6b7'
      },
      {
        ch: '🚯',
        cp: '1f6af'
      },
      {
        ch: '🚳',
        cp: '1f6b3'
      },
      {
        ch: '🚱',
        cp: '1f6b1'
      },
      {
        ch: '🔞',
        cp: '1f51e'
      },
      {
        ch: '📵',
        cp: '1f4f5'
      },
      {
        ch: '🚭',
        cp: '1f6ad'
      },
      {
        ch: '❗',
        cp: '2757'
      },
      {
        ch: '❕',
        cp: '2755'
      },
      {
        ch: '❓',
        cp: '2753'
      },
      {
        ch: '❔',
        cp: '2754'
      },
      {
        ch: '‼',
        cp: '203c'
      },
      {
        ch: '⁉',
        cp: '2049'
      },
      {
        ch: '💯',
        cp: '1f4af'
      },
      {
        ch: '🔅',
        cp: '1f505'
      },
      {
        ch: '🔆',
        cp: '1f506'
      },
      {
        ch: '🔱',
        cp: '1f531'
      },
      {
        ch: '⚜',
        cp: '269c'
      },
      {
        ch: '〽',
        cp: '303d'
      },
      {
        ch: '⚠',
        cp: '26a0'
      },
      {
        ch: '🚸',
        cp: '1f6b8'
      },
      {
        ch: '🔰',
        cp: '1f530'
      },
      {
        ch: '♻',
        cp: '267b'
      },
      {
        ch: '🈯',
        cp: '1f22f'
      },
      {
        ch: '💹',
        cp: '1f4b9'
      },
      {
        ch: '❇',
        cp: '2747'
      },
      {
        ch: '✳',
        cp: '2733'
      },
      {
        ch: '❎',
        cp: '274e'
      },
      {
        ch: '✅',
        cp: '2705'
      },
      {
        ch: '💠',
        cp: '1f4a0'
      },
      {
        ch: '🌀',
        cp: '1f300'
      },
      {
        ch: '➿',
        cp: '27bf'
      },
      {
        ch: '🌐',
        cp: '1f310'
      },
      {
        ch: '♾',
        cp: '267e'
      },
      {
        ch: 'Ⓜ',
        cp: '24c2'
      },
      {
        ch: '🏧',
        cp: '1f3e7'
      },
      {
        ch: '🚾',
        cp: '1f6be'
      },
      {
        ch: '♿',
        cp: '267f'
      },
      {
        ch: '🅿',
        cp: '1f17f'
      },
      {
        ch: '🈳',
        cp: '1f233'
      },
      {
        ch: '🈂',
        cp: '1f202'
      },
      {
        ch: '🛂',
        cp: '1f6c2'
      },
      {
        ch: '🛃',
        cp: '1f6c3'
      },
      {
        ch: '🛄',
        cp: '1f6c4'
      },
      {
        ch: '🛅',
        cp: '1f6c5'
      },
      {
        ch: '🚰',
        cp: '1f6b0'
      },
      {
        ch: '🚹',
        cp: '1f6b9'
      },
      {
        ch: '♂',
        cp: '2642'
      },
      {
        ch: '🚺',
        cp: '1f6ba'
      },
      {
        ch: '♀',
        cp: '2640'
      },
      {
        ch: '🚼',
        cp: '1f6bc'
      },
      {
        ch: '🚻',
        cp: '1f6bb'
      },
      {
        ch: '🚮',
        cp: '1f6ae'
      },
      {
        ch: '🎦',
        cp: '1f3a6'
      },
      {
        ch: '📶',
        cp: '1f4f6'
      },
      {
        ch: '🈁',
        cp: '1f201'
      },
      {
        ch: '🆖',
        cp: '1f196'
      },
      {
        ch: '🆗',
        cp: '1f197'
      },
      {
        ch: '🆙',
        cp: '1f199'
      },
      {
        ch: '🆒',
        cp: '1f192'
      },
      {
        ch: '🆕',
        cp: '1f195'
      },
      {
        ch: '🆓',
        cp: '1f193'
      },
      {
        ch: '0⃣',
        cp: '30-20e3'
      },
      {
        ch: '1⃣',
        cp: '31-20e3'
      },
      {
        ch: '2⃣',
        cp: '32-20e3'
      },
      {
        ch: '3⃣',
        cp: '33-20e3'
      },
      {
        ch: '4⃣',
        cp: '34-20e3'
      },
      {
        ch: '5⃣',
        cp: '35-20e3'
      },
      {
        ch: '6⃣',
        cp: '36-20e3'
      },
      {
        ch: '7⃣',
        cp: '37-20e3'
      },
      {
        ch: '8⃣',
        cp: '38-20e3'
      },
      {
        ch: '9⃣',
        cp: '39-20e3'
      },
      {
        ch: '🔟',
        cp: '1f51f'
      },
      {
        ch: '🔢',
        cp: '1f522'
      },
      {
        ch: '▶',
        cp: '25b6'
      },
      {
        ch: '⏸',
        cp: '23f8'
      },
      {
        ch: '⏯',
        cp: '23ef'
      },
      {
        ch: '⏹',
        cp: '23f9'
      },
      {
        ch: '⏺',
        cp: '23fa'
      },
      {
        ch: '⏏',
        cp: '23cf'
      },
      {
        ch: '⏭',
        cp: '23ed'
      },
      {
        ch: '⏮',
        cp: '23ee'
      },
      {
        ch: '⏩',
        cp: '23e9'
      },
      {
        ch: '⏪',
        cp: '23ea'
      },
      {
        ch: '🔀',
        cp: '1f500'
      },
      {
        ch: '🔁',
        cp: '1f501'
      },
      {
        ch: '🔂',
        cp: '1f502'
      },
      {
        ch: '◀',
        cp: '25c0'
      },
      {
        ch: '🔼',
        cp: '1f53c'
      },
      {
        ch: '🔽',
        cp: '1f53d'
      },
      {
        ch: '⏫',
        cp: '23eb'
      },
      {
        ch: '⏬',
        cp: '23ec'
      },
      {
        ch: '➡',
        cp: '27a1'
      },
      {
        ch: '⬅',
        cp: '2b05'
      },
      {
        ch: '⬆',
        cp: '2b06'
      },
      {
        ch: '⬇',
        cp: '2b07'
      },
      {
        ch: '↗',
        cp: '2197'
      },
      {
        ch: '↘',
        cp: '2198'
      },
      {
        ch: '↙',
        cp: '2199'
      },
      {
        ch: '↖',
        cp: '2196'
      },
      {
        ch: '↕',
        cp: '2195'
      },
      {
        ch: '↔',
        cp: '2194'
      },
      {
        ch: '🔄',
        cp: '1f504'
      },
      {
        ch: '↪',
        cp: '21aa'
      },
      {
        ch: '↩',
        cp: '21a9'
      },
      {
        ch: '🔃',
        cp: '1f503'
      },
      {
        ch: '⤴',
        cp: '2934'
      },
      {
        ch: '⤵',
        cp: '2935'
      },
      {
        ch: '#⃣',
        cp: '23-20e3'
      },
      {
        ch: '*⃣',
        cp: '2a-20e3'
      },
      {
        ch: 'ℹ',
        cp: '2139'
      },
      {
        ch: '🔤',
        cp: '1f524'
      },
      {
        ch: '🔡',
        cp: '1f521'
      },
      {
        ch: '🔠',
        cp: '1f520'
      },
      {
        ch: '🔣',
        cp: '1f523'
      },
      {
        ch: '🎵',
        cp: '1f3b5'
      },
      {
        ch: '🎶',
        cp: '1f3b6'
      },
      {
        ch: '〰',
        cp: '3030'
      },
      {
        ch: '➰',
        cp: '27b0'
      },
      {
        ch: '✔',
        cp: '2714'
      },
      {
        ch: '➕',
        cp: '2795'
      },
      {
        ch: '➖',
        cp: '2796'
      },
      {
        ch: '➗',
        cp: '2797'
      },
      {
        ch: '✖',
        cp: '2716'
      },
      {
        ch: '💲',
        cp: '1f4b2'
      },
      {
        ch: '💱',
        cp: '1f4b1'
      },
      {
        ch: '©️',
        cp: 'a9'
      },
      {
        ch: '®️',
        cp: 'ae'
      },
      {
        ch: '™️',
        cp: '2122'
      },
      {
        ch: '🔚',
        cp: '1f51a'
      },
      {
        ch: '🔙',
        cp: '1f519'
      },
      {
        ch: '🔛',
        cp: '1f51b'
      },
      {
        ch: '🔝',
        cp: '1f51d'
      },
      {
        ch: '🔜',
        cp: '1f51c'
      },
      {
        ch: '☑',
        cp: '2611'
      },
      {
        ch: '🔘',
        cp: '1f518'
      },
      {
        ch: '⚪',
        cp: '26aa'
      },
      {
        ch: '⚫',
        cp: '26ab'
      },
      {
        ch: '🔴',
        cp: '1f534'
      },
      {
        ch: '🔵',
        cp: '1f535'
      },
      {
        ch: '🔸',
        cp: '1f538'
      },
      {
        ch: '🔹',
        cp: '1f539'
      },
      {
        ch: '🔶',
        cp: '1f536'
      },
      {
        ch: '🔷',
        cp: '1f537'
      },
      {
        ch: '🔺',
        cp: '1f53a'
      },
      {
        ch: '▪',
        cp: '25aa'
      },
      {
        ch: '▫',
        cp: '25ab'
      },
      {
        ch: '⬛',
        cp: '2b1b'
      },
      {
        ch: '⬜',
        cp: '2b1c'
      },
      {
        ch: '🔻',
        cp: '1f53b'
      },
      {
        ch: '◼',
        cp: '25fc'
      },
      {
        ch: '◻',
        cp: '25fb'
      },
      {
        ch: '◾',
        cp: '25fe'
      },
      {
        ch: '◽',
        cp: '25fd'
      },
      {
        ch: '🔲',
        cp: '1f532'
      },
      {
        ch: '🔳',
        cp: '1f533'
      },
      {
        ch: '🔈',
        cp: '1f508'
      },
      {
        ch: '🔉',
        cp: '1f509'
      },
      {
        ch: '🔊',
        cp: '1f50a'
      },
      {
        ch: '🔇',
        cp: '1f507'
      },
      {
        ch: '📣',
        cp: '1f4e3'
      },
      {
        ch: '📢',
        cp: '1f4e2'
      },
      {
        ch: '🔔',
        cp: '1f514'
      },
      {
        ch: '🔕',
        cp: '1f515'
      },
      {
        ch: '🃏',
        cp: '1f0cf'
      },
      {
        ch: '🀄',
        cp: '1f004'
      },
      {
        ch: '♠',
        cp: '2660'
      },
      {
        ch: '♣',
        cp: '2663'
      },
      {
        ch: '♥',
        cp: '2665'
      },
      {
        ch: '♦',
        cp: '2666'
      },
      {
        ch: '🎴',
        cp: '1f3b4'
      },
      {
        ch: '👁‍🗨',
        cp: '1f441-200d-1f5e8'
      },
      {
        ch: '🗨',
        cp: '1f5e8'
      },
      {
        ch: '💭',
        cp: '1f4ad'
      },
      {
        ch: '🗯',
        cp: '1f5ef'
      },
      {
        ch: '💬',
        cp: '1f4ac'
      },
      {
        ch: '🕐',
        cp: '1f550'
      },
      {
        ch: '🕑',
        cp: '1f551'
      },
      {
        ch: '🕒',
        cp: '1f552'
      },
      {
        ch: '🕓',
        cp: '1f553'
      },
      {
        ch: '🕔',
        cp: '1f554'
      },
      {
        ch: '🕕',
        cp: '1f555'
      },
      {
        ch: '🕖',
        cp: '1f556'
      },
      {
        ch: '🕗',
        cp: '1f557'
      },
      {
        ch: '🕘',
        cp: '1f558'
      },
      {
        ch: '🕙',
        cp: '1f559'
      },
      {
        ch: '🕚',
        cp: '1f55a'
      },
      {
        ch: '🕛',
        cp: '1f55b'
      },
      {
        ch: '🕜',
        cp: '1f55c'
      },
      {
        ch: '🕝',
        cp: '1f55d'
      },
      {
        ch: '🕞',
        cp: '1f55e'
      },
      {
        ch: '🕟',
        cp: '1f55f'
      },
      {
        ch: '🕠',
        cp: '1f560'
      },
      {
        ch: '🕡',
        cp: '1f561'
      },
      {
        ch: '🕢',
        cp: '1f562'
      },
      {
        ch: '🕣',
        cp: '1f563'
      },
      {
        ch: '🕤',
        cp: '1f564'
      },
      {
        ch: '🕥',
        cp: '1f565'
      },
      {
        ch: '🕦',
        cp: '1f566'
      },
      {
        ch: '🕧',
        cp: '1f567'
      },
    ],
  },
  {
    label: {
      translate: 'emoji.label.flags',
      fix: 'Drapeaux'
    },
    icon: {
      ch: '🏳',
      cp: '1f3f3'
    },
    emojis: [{
        ch: '🏳',
        cp: '1f3f3'
      },
      {
        ch: '🏴',
        cp: '1f3f4'
      },
      {
        ch: '🏁',
        cp: '1f3c1'
      },
      {
        ch: '🚩',
        cp: '1f6a9'
      },
      {
        ch: '🎌',
        cp: '1f38c'
      },
      {
        ch: '🏴‍☠️',
        cp: '1f3f4-200d-2620-fe0f'
      },
      {
        ch: '🏳️‍🌈',
        cp: '1f3f3-fe0f-200d-1f308'
      },
      {
        ch: '🇦🇨',
        cp: '1f1e6-1f1e8'
      },
      {
        ch: '🇦🇩',
        cp: '1f1e6-1f1e9'
      },
      {
        ch: '🇦🇪',
        cp: '1f1e6-1f1ea'
      },
      {
        ch: '🇦🇫',
        cp: '1f1e6-1f1eb'
      },
      {
        ch: '🇦🇬',
        cp: '1f1e6-1f1ec'
      },
      {
        ch: '🇦🇮',
        cp: '1f1e6-1f1ee'
      },
      {
        ch: '🇦🇱',
        cp: '1f1e6-1f1f1'
      },
      {
        ch: '🇦🇲',
        cp: '1f1e6-1f1f2'
      },
      {
        ch: '🇦🇴',
        cp: '1f1e6-1f1f4'
      },
      {
        ch: '🇦🇶',
        cp: '1f1e6-1f1f6'
      },
      {
        ch: '🇦🇷',
        cp: '1f1e6-1f1f7'
      },
      {
        ch: '🇦🇸',
        cp: '1f1e6-1f1f8'
      },
      {
        ch: '🇦🇹',
        cp: '1f1e6-1f1f9'
      },
      {
        ch: '🇦🇺',
        cp: '1f1e6-1f1fa'
      },
      {
        ch: '🇦🇼',
        cp: '1f1e6-1f1fc'
      },
      {
        ch: '🇦🇽',
        cp: '1f1e6-1f1fd'
      },
      {
        ch: '🇦🇿',
        cp: '1f1e6-1f1ff'
      },
      {
        ch: '🇧🇦',
        cp: '1f1e7-1f1e6'
      },
      {
        ch: '🇧🇧',
        cp: '1f1e7-1f1e7'
      },
      {
        ch: '🇧🇩',
        cp: '1f1e7-1f1e9'
      },
      {
        ch: '🇧🇪',
        cp: '1f1e7-1f1ea'
      },
      {
        ch: '🇧🇫',
        cp: '1f1e7-1f1eb'
      },
      {
        ch: '🇧🇬',
        cp: '1f1e7-1f1ec'
      },
      {
        ch: '🇧🇭',
        cp: '1f1e7-1f1ed'
      },
      {
        ch: '🇧🇮',
        cp: '1f1e7-1f1ee'
      },
      {
        ch: '🇧🇯',
        cp: '1f1e7-1f1ef'
      },
      {
        ch: '🇧🇱',
        cp: '1f1e7-1f1f1'
      },
      {
        ch: '🇧🇲',
        cp: '1f1e7-1f1f2'
      },
      {
        ch: '🇧🇳',
        cp: '1f1e7-1f1f3'
      },
      {
        ch: '🇧🇴',
        cp: '1f1e7-1f1f4'
      },
      {
        ch: '🇧🇶',
        cp: '1f1e7-1f1f6'
      },
      {
        ch: '🇧🇷',
        cp: '1f1e7-1f1f7'
      },
      {
        ch: '🇧🇸',
        cp: '1f1e7-1f1f8'
      },
      {
        ch: '🇧🇹',
        cp: '1f1e7-1f1f9'
      },
      {
        ch: '🇧🇼',
        cp: '1f1e7-1f1fc'
      },
      {
        ch: '🇧🇾',
        cp: '1f1e7-1f1fe'
      },
      {
        ch: '🇧🇿',
        cp: '1f1e7-1f1ff'
      },
      {
        ch: '🇨🇦',
        cp: '1f1e8-1f1e6'
      },
      {
        ch: '🇨🇨',
        cp: '1f1e8-1f1e8'
      },
      {
        ch: '🇨🇩',
        cp: '1f1e8-1f1e9'
      },
      {
        ch: '🇨🇫',
        cp: '1f1e8-1f1eb'
      },
      {
        ch: '🇨🇬',
        cp: '1f1e8-1f1ec'
      },
      {
        ch: '🇨🇭',
        cp: '1f1e8-1f1ed'
      },
      {
        ch: '🇨🇮',
        cp: '1f1e8-1f1ee'
      },
      {
        ch: '🇨🇰',
        cp: '1f1e8-1f1f0'
      },
      {
        ch: '🇨🇱',
        cp: '1f1e8-1f1f1'
      },
      {
        ch: '🇨🇲',
        cp: '1f1e8-1f1f2'
      },
      {
        ch: '🇨🇳',
        cp: '1f1e8-1f1f3'
      },
      {
        ch: '🇨🇴',
        cp: '1f1e8-1f1f4'
      },
      {
        ch: '🇨🇷',
        cp: '1f1e8-1f1f7'
      },
      {
        ch: '🇨🇺',
        cp: '1f1e8-1f1fa'
      },
      {
        ch: '🇨🇻',
        cp: '1f1e8-1f1fb'
      },
      {
        ch: '🇨🇼',
        cp: '1f1e8-1f1fc'
      },
      {
        ch: '🇨🇽',
        cp: '1f1e8-1f1fd'
      },
      {
        ch: '🇨🇾',
        cp: '1f1e8-1f1fe'
      },
      {
        ch: '🇨🇿',
        cp: '1f1e8-1f1ff'
      },
      {
        ch: '🇩🇪',
        cp: '1f1e9-1f1ea'
      },
      {
        ch: '🇩🇯',
        cp: '1f1e9-1f1ef'
      },
      {
        ch: '🇩🇰',
        cp: '1f1e9-1f1f0'
      },
      {
        ch: '🇩🇲',
        cp: '1f1e9-1f1f2'
      },
      {
        ch: '🇩🇴',
        cp: '1f1e9-1f1f4'
      },
      {
        ch: '🇩🇿',
        cp: '1f1e9-1f1ff'
      },
      {
        ch: '🇪🇨',
        cp: '1f1ea-1f1e8'
      },
      {
        ch: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
        cp: '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f'
      },
      {
        ch: '🇪🇪',
        cp: '1f1ea-1f1ea'
      },
      {
        ch: '🇪🇬',
        cp: '1f1ea-1f1ec'
      },
      {
        ch: '🇪🇭',
        cp: '1f1ea-1f1ed'
      },
      {
        ch: '🇪🇷',
        cp: '1f1ea-1f1f7'
      },
      {
        ch: '🇪🇸',
        cp: '1f1ea-1f1f8'
      },
      {
        ch: '🇪🇹',
        cp: '1f1ea-1f1f9'
      },
      {
        ch: '🇪🇺',
        cp: '1f1ea-1f1fa'
      },
      {
        ch: '🇫🇮',
        cp: '1f1eb-1f1ee'
      },
      {
        ch: '🇫🇯',
        cp: '1f1eb-1f1ef'
      },
      {
        ch: '🇫🇰',
        cp: '1f1eb-1f1f0'
      },
      {
        ch: '🇫🇲',
        cp: '1f1eb-1f1f2'
      },
      {
        ch: '🇫🇴',
        cp: '1f1eb-1f1f4'
      },
      {
        ch: '🇫🇷',
        cp: '1f1eb-1f1f7'
      },
      {
        ch: '🇬🇦',
        cp: '1f1ec-1f1e6'
      },
      {
        ch: '🇬🇧',
        cp: '1f1ec-1f1e7'
      },
      {
        ch: '🇬🇩',
        cp: '1f1ec-1f1e9'
      },
      {
        ch: '🇬🇪',
        cp: '1f1ec-1f1ea'
      },
      {
        ch: '🇬🇫',
        cp: '1f1ec-1f1eb'
      },
      {
        ch: '🇬🇬',
        cp: '1f1ec-1f1ec'
      },
      {
        ch: '🇬🇭',
        cp: '1f1ec-1f1ed'
      },
      {
        ch: '🇬🇮',
        cp: '1f1ec-1f1ee'
      },
      {
        ch: '🇬🇱',
        cp: '1f1ec-1f1f1'
      },
      {
        ch: '🇬🇲',
        cp: '1f1ec-1f1f2'
      },
      {
        ch: '🇬🇳',
        cp: '1f1ec-1f1f3'
      },
      {
        ch: '🇬🇵',
        cp: '1f1ec-1f1f5'
      },
      {
        ch: '🇬🇶',
        cp: '1f1ec-1f1f6'
      },
      {
        ch: '🇬🇷',
        cp: '1f1ec-1f1f7'
      },
      {
        ch: '🇬🇸',
        cp: '1f1ec-1f1f8'
      },
      {
        ch: '🇬🇹',
        cp: '1f1ec-1f1f9'
      },
      {
        ch: '🇬🇺',
        cp: '1f1ec-1f1fa'
      },
      {
        ch: '🇬🇼',
        cp: '1f1ec-1f1fc'
      },
      {
        ch: '🇬🇾',
        cp: '1f1ec-1f1fe'
      },
      {
        ch: '🇭🇰',
        cp: '1f1ed-1f1f0'
      },
      {
        ch: '🇭🇳',
        cp: '1f1ed-1f1f3'
      },
      {
        ch: '🇭🇷',
        cp: '1f1ed-1f1f7'
      },
      {
        ch: '🇭🇹',
        cp: '1f1ed-1f1f9'
      },
      {
        ch: '🇭🇺',
        cp: '1f1ed-1f1fa'
      },
      {
        ch: '🇮🇨',
        cp: '1f1ee-1f1e8'
      },
      {
        ch: '🇮🇩',
        cp: '1f1ee-1f1e9'
      },
      {
        ch: '🇮🇪',
        cp: '1f1ee-1f1ea'
      },
      {
        ch: '🇮🇱',
        cp: '1f1ee-1f1f1'
      },
      {
        ch: '🇮🇲',
        cp: '1f1ee-1f1f2'
      },
      {
        ch: '🇮🇳',
        cp: '1f1ee-1f1f3'
      },
      {
        ch: '🇮🇴',
        cp: '1f1ee-1f1f4'
      },
      {
        ch: '🇮🇶',
        cp: '1f1ee-1f1f6'
      },
      {
        ch: '🇮🇷',
        cp: '1f1ee-1f1f7'
      },
      {
        ch: '🇮🇸',
        cp: '1f1ee-1f1f8'
      },
      {
        ch: '🇮🇹',
        cp: '1f1ee-1f1f9'
      },
      {
        ch: '🇯🇪',
        cp: '1f1ef-1f1ea'
      },
      {
        ch: '🇯🇲',
        cp: '1f1ef-1f1f2'
      },
      {
        ch: '🇯🇴',
        cp: '1f1ef-1f1f4'
      },
      {
        ch: '🇯🇵',
        cp: '1f1ef-1f1f5'
      },
      {
        ch: '🇰🇪',
        cp: '1f1f0-1f1ea'
      },
      {
        ch: '🇰🇬',
        cp: '1f1f0-1f1ec'
      },
      {
        ch: '🇰🇭',
        cp: '1f1f0-1f1ed'
      },
      {
        ch: '🇰🇮',
        cp: '1f1f0-1f1ee'
      },
      {
        ch: '🇰🇲',
        cp: '1f1f0-1f1f2'
      },
      {
        ch: '🇰🇳',
        cp: '1f1f0-1f1f3'
      },
      {
        ch: '🇰🇵',
        cp: '1f1f0-1f1f5'
      },
      {
        ch: '🇰🇷',
        cp: '1f1f0-1f1f7'
      },
      {
        ch: '🇰🇼',
        cp: '1f1f0-1f1fc'
      },
      {
        ch: '🇰🇾',
        cp: '1f1f0-1f1fe'
      },
      {
        ch: '🇰🇿',
        cp: '1f1f0-1f1ff'
      },
      {
        ch: '🇱🇦',
        cp: '1f1f1-1f1e6'
      },
      {
        ch: '🇱🇧',
        cp: '1f1f1-1f1e7'
      },
      {
        ch: '🇱🇨',
        cp: '1f1f1-1f1e8'
      },
      {
        ch: '🇱🇮',
        cp: '1f1f1-1f1ee'
      },
      {
        ch: '🇱🇰',
        cp: '1f1f1-1f1f0'
      },
      {
        ch: '🇱🇷',
        cp: '1f1f1-1f1f7'
      },
      {
        ch: '🇱🇸',
        cp: '1f1f1-1f1f8'
      },
      {
        ch: '🇱🇹',
        cp: '1f1f1-1f1f9'
      },
      {
        ch: '🇱🇺',
        cp: '1f1f1-1f1fa'
      },
      {
        ch: '🇱🇻',
        cp: '1f1f1-1f1fb'
      },
      {
        ch: '🇱🇾',
        cp: '1f1f1-1f1fe'
      },
      {
        ch: '🇲🇦',
        cp: '1f1f2-1f1e6'
      },
      {
        ch: '🇲🇨',
        cp: '1f1f2-1f1e8'
      },
      {
        ch: '🇲🇩',
        cp: '1f1f2-1f1e9'
      },
      {
        ch: '🇲🇪',
        cp: '1f1f2-1f1ea'
      },
      {
        ch: '🇲🇬',
        cp: '1f1f2-1f1ec'
      },
      {
        ch: '🇲🇭',
        cp: '1f1f2-1f1ed'
      },
      {
        ch: '🇲🇰',
        cp: '1f1f2-1f1f0'
      },
      {
        ch: '🇲🇱',
        cp: '1f1f2-1f1f1'
      },
      {
        ch: '🇲🇲',
        cp: '1f1f2-1f1f2'
      },
      {
        ch: '🇲🇳',
        cp: '1f1f2-1f1f3'
      },
      {
        ch: '🇲🇴',
        cp: '1f1f2-1f1f4'
      },
      {
        ch: '🇲🇵',
        cp: '1f1f2-1f1f5'
      },
      {
        ch: '🇲🇶',
        cp: '1f1f2-1f1f6'
      },
      {
        ch: '🇲🇷',
        cp: '1f1f2-1f1f7'
      },
      {
        ch: '🇲🇸',
        cp: '1f1f2-1f1f8'
      },
      {
        ch: '🇲🇹',
        cp: '1f1f2-1f1f9'
      },
      {
        ch: '🇲🇺',
        cp: '1f1f2-1f1fa'
      },
      {
        ch: '🇲🇻',
        cp: '1f1f2-1f1fb'
      },
      {
        ch: '🇲🇼',
        cp: '1f1f2-1f1fc'
      },
      {
        ch: '🇲🇽',
        cp: '1f1f2-1f1fd'
      },
      {
        ch: '🇲🇾',
        cp: '1f1f2-1f1fe'
      },
      {
        ch: '🇲🇿',
        cp: '1f1f2-1f1ff'
      },
      {
        ch: '🇳🇦',
        cp: '1f1f3-1f1e6'
      },
      {
        ch: '🇳🇨',
        cp: '1f1f3-1f1e8'
      },
      {
        ch: '🇳🇪',
        cp: '1f1f3-1f1ea'
      },
      {
        ch: '🇳🇫',
        cp: '1f1f3-1f1eb'
      },
      {
        ch: '🇳🇬',
        cp: '1f1f3-1f1ec'
      },
      {
        ch: '🇳🇮',
        cp: '1f1f3-1f1ee'
      },
      {
        ch: '🇳🇱',
        cp: '1f1f3-1f1f1'
      },
      {
        ch: '🇳🇴',
        cp: '1f1f3-1f1f4'
      },
      {
        ch: '🇳🇵',
        cp: '1f1f3-1f1f5'
      },
      {
        ch: '🇳🇷',
        cp: '1f1f3-1f1f7'
      },
      {
        ch: '🇳🇺',
        cp: '1f1f3-1f1fa'
      },
      {
        ch: '🇳🇿',
        cp: '1f1f3-1f1ff'
      },
      {
        ch: '🇴🇲',
        cp: '1f1f4-1f1f2'
      },
      {
        ch: '🇵🇦',
        cp: '1f1f5-1f1e6'
      },
      {
        ch: '🇵🇪',
        cp: '1f1f5-1f1ea'
      },
      {
        ch: '🇵🇫',
        cp: '1f1f5-1f1eb'
      },
      {
        ch: '🇵🇬',
        cp: '1f1f5-1f1ec'
      },
      {
        ch: '🇵🇭',
        cp: '1f1f5-1f1ed'
      },
      {
        ch: '🇵🇰',
        cp: '1f1f5-1f1f0'
      },
      {
        ch: '🇵🇱',
        cp: '1f1f5-1f1f1'
      },
      {
        ch: '🇵🇲',
        cp: '1f1f5-1f1f2'
      },
      {
        ch: '🇵🇳',
        cp: '1f1f5-1f1f3'
      },
      {
        ch: '🇵🇷',
        cp: '1f1f5-1f1f7'
      },
      {
        ch: '🇵🇸',
        cp: '1f1f5-1f1f8'
      },
      {
        ch: '🇵🇹',
        cp: '1f1f5-1f1f9'
      },
      {
        ch: '🇵🇼',
        cp: '1f1f5-1f1fc'
      },
      {
        ch: '🇵🇾',
        cp: '1f1f5-1f1fe'
      },
      {
        ch: '🇶🇦',
        cp: '1f1f6-1f1e6'
      },
      {
        ch: '🇷🇪',
        cp: '1f1f7-1f1ea'
      },
      {
        ch: '🇷🇴',
        cp: '1f1f7-1f1f4'
      },
      {
        ch: '🇷🇸',
        cp: '1f1f7-1f1f8'
      },
      {
        ch: '🇷🇺',
        cp: '1f1f7-1f1fa'
      },
      {
        ch: '🇷🇼',
        cp: '1f1f7-1f1fc'
      },
      {
        ch: '🇸🇦',
        cp: '1f1f8-1f1e6'
      },
      {
        ch: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
        cp: '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f'
      },
      {
        ch: '🇸🇧',
        cp: '1f1f8-1f1e7'
      },
      {
        ch: '🇸🇨',
        cp: '1f1f8-1f1e8'
      },
      {
        ch: '🇸🇩',
        cp: '1f1f8-1f1e9'
      },
      {
        ch: '🇸🇪',
        cp: '1f1f8-1f1ea'
      },
      {
        ch: '🇸🇬',
        cp: '1f1f8-1f1ec'
      },
      {
        ch: '🇸🇭',
        cp: '1f1f8-1f1ed'
      },
      {
        ch: '🇸🇮',
        cp: '1f1f8-1f1ee'
      },
      {
        ch: '🇸🇰',
        cp: '1f1f8-1f1f0'
      },
      {
        ch: '🇸🇱',
        cp: '1f1f8-1f1f1'
      },
      {
        ch: '🇸🇲',
        cp: '1f1f8-1f1f2'
      },
      {
        ch: '🇸🇳',
        cp: '1f1f8-1f1f3'
      },
      {
        ch: '🇸🇴',
        cp: '1f1f8-1f1f4'
      },
      {
        ch: '🇸🇷',
        cp: '1f1f8-1f1f7'
      },
      {
        ch: '🇸🇸',
        cp: '1f1f8-1f1f8'
      },
      {
        ch: '🇸🇹',
        cp: '1f1f8-1f1f9'
      },
      {
        ch: '🇸🇻',
        cp: '1f1f8-1f1fb'
      },
      {
        ch: '🇸🇽',
        cp: '1f1f8-1f1fd'
      },
      {
        ch: '🇸🇾',
        cp: '1f1f8-1f1fe'
      },
      {
        ch: '🇸🇿',
        cp: '1f1f8-1f1ff'
      },
      {
        ch: '🇹🇦',
        cp: '1f1f9-1f1e6'
      },
      {
        ch: '🇹🇨',
        cp: '1f1f9-1f1e8'
      },
      {
        ch: '🇹🇩',
        cp: '1f1f9-1f1e9'
      },
      {
        ch: '🇹🇫',
        cp: '1f1f9-1f1eb'
      },
      {
        ch: '🇹🇬',
        cp: '1f1f9-1f1ec'
      },
      {
        ch: '🇹🇭',
        cp: '1f1f9-1f1ed'
      },
      {
        ch: '🇹🇯',
        cp: '1f1f9-1f1ef'
      },
      {
        ch: '🇹🇰',
        cp: '1f1f9-1f1f0'
      },
      {
        ch: '🇹🇱',
        cp: '1f1f9-1f1f1'
      },
      {
        ch: '🇹🇲',
        cp: '1f1f9-1f1f2'
      },
      {
        ch: '🇹🇳',
        cp: '1f1f9-1f1f3'
      },
      {
        ch: '🇹🇴',
        cp: '1f1f9-1f1f4'
      },
      {
        ch: '🇹🇷',
        cp: '1f1f9-1f1f7'
      },
      {
        ch: '🇹🇹',
        cp: '1f1f9-1f1f9'
      },
      {
        ch: '🇹🇻',
        cp: '1f1f9-1f1fb'
      },
      {
        ch: '🇹🇼',
        cp: '1f1f9-1f1fc'
      },
      {
        ch: '🇹🇿',
        cp: '1f1f9-1f1ff'
      },
      {
        ch: '🇺🇦',
        cp: '1f1fa-1f1e6'
      },
      {
        ch: '🇺🇬',
        cp: '1f1fa-1f1ec'
      },
      {
        ch: '🇺🇳',
        cp: '1f1fa-1f1f3'
      },
      {
        ch: '🇺🇸',
        cp: '1f1fa-1f1f8'
      },
      {
        ch: '🇺🇾',
        cp: '1f1fa-1f1fe'
      },
      {
        ch: '🇺🇿',
        cp: '1f1fa-1f1ff'
      },
      {
        ch: '🇻🇦',
        cp: '1f1fb-1f1e6'
      },
      {
        ch: '🇻🇨',
        cp: '1f1fb-1f1e8'
      },
      {
        ch: '🇻🇪',
        cp: '1f1fb-1f1ea'
      },
      {
        ch: '🇻🇬',
        cp: '1f1fb-1f1ec'
      },
      {
        ch: '🇻🇮',
        cp: '1f1fb-1f1ee'
      },
      {
        ch: '🇻🇳',
        cp: '1f1fb-1f1f3'
      },
      {
        ch: '🇻🇺',
        cp: '1f1fb-1f1fa'
      },
      {
        ch: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
        cp: '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f'
      },
      {
        ch: '🇼🇫',
        cp: '1f1fc-1f1eb'
      },
      {
        ch: '🇼🇸',
        cp: '1f1fc-1f1f8'
      },
      {
        ch: '🇽🇰',
        cp: '1f1fd-1f1f0'
      },
      {
        ch: '🇾🇪',
        cp: '1f1fe-1f1ea'
      },
      {
        ch: '🇾🇹',
        cp: '1f1fe-1f1f9'
      },
      {
        ch: '🇿🇦',
        cp: '1f1ff-1f1e6'
      },
      {
        ch: '🇿🇲',
        cp: '1f1ff-1f1f2'
      },
      {
        ch: '🇿🇼',
        cp: '1f1ff-1f1fc'
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/model/emoji/EmojiList.js